window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.Arrow = function() {
	this.initialize(img.MainAssets_Arrow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,30);


(lib.Background_Blue = function() {
	this.initialize(img.MainAssets_Background_Blue);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,977,2052);


(lib.Boy = function() {
	this.initialize(img.MainAssets_Boy);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,123,176);


(lib.Boy_ClosedEyes = function() {
	this.initialize(img.MainAssets_Boy_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,123,176);


(lib.Button_disabled = function() {
	this.initialize(img.MainAssets_Button_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Button_down = function() {
	this.initialize(img.MainAssets_Button_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Button_up = function() {
	this.initialize(img.MainAssets_Button_up);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Cabbage = function() {
	this.initialize(img.MainAssets_Cabbage);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,198,141);


(lib.Carrot = function() {
	this.initialize(img.MainAssets_Carrot);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,203,111);


(lib.Caterpillar = function() {
	this.initialize(img.MainAssets_Caterpillar);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,169,131);


(lib.Caterpillar_ClosedEyes = function() {
	this.initialize(img.MainAssets_Caterpillar_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,169,131);


(lib.CharacterShadow = function() {
	this.initialize(img.MainAssets_CharacterShadow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,294,163);


(lib.Chicken = function() {
	this.initialize(img.MainAssets_Chicken);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,172,204);


(lib.Chicken__ClosedEyes = function() {
	this.initialize(img.MainAssets_Chicken__ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,172,204);


(lib.Dog = function() {
	this.initialize(img.MainAssets_Dog);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,246,245);


(lib.Dog_ClosedEyes = function() {
	this.initialize(img.MainAssets_Dog_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,246,245);


(lib.Euromast = function() {
	this.initialize(img.MainAssets_Euromast);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,736,818);


(lib.Farmer = function() {
	this.initialize(img.MainAssets_Farmer);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,183,330);


(lib.Farmer_ClosedEyes = function() {
	this.initialize(img.MainAssets_Farmer_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,183,330);


(lib.Father = function() {
	this.initialize(img.MainAssets_Father);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,164,235);


(lib.Father_ClosedEyes = function() {
	this.initialize(img.MainAssets_Father_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,164,235);


(lib.FeedbackPopup_Left = function() {
	this.initialize(img.MainAssets_FeedbackPopup_Left);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,75);


(lib.FeedbackPopup_Middle = function() {
	this.initialize(img.MainAssets_FeedbackPopup_Middle);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,126,75);


(lib.FeedbackPopup_Right = function() {
	this.initialize(img.MainAssets_FeedbackPopup_Right);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,75);


(lib.Ferry = function() {
	this.initialize(img.MainAssets_Ferry);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,677,534);


(lib.Ferry_ClosedEyes = function() {
	this.initialize(img.MainAssets_Ferry_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,677,534);


(lib.Fish_01 = function() {
	this.initialize(img.MainAssets_Fish_01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,72,55);


(lib.Fish_02 = function() {
	this.initialize(img.MainAssets_Fish_02);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,82,62);


(lib.Foreground_Splash = function() {
	this.initialize(img.MainAssets_Foreground_Splash);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1332,2108);


(lib.Fox = function() {
	this.initialize(img.MainAssets_Fox);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,286,254);


(lib.Fox_ClosedEyes = function() {
	this.initialize(img.MainAssets_Fox_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,286,254);


(lib.gatekeeper = function() {
	this.initialize(img.MainAssets_gatekeeper);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1349,2131);


(lib.Girl = function() {
	this.initialize(img.MainAssets_Girl);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,155,176);


(lib.Girl_ClosedEyes = function() {
	this.initialize(img.MainAssets_Girl_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,155,176);


(lib.Goat = function() {
	this.initialize(img.MainAssets_Goat);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,236,261);


(lib.Goat_ClosedEyes = function() {
	this.initialize(img.MainAssets_Goat_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,236,261);


(lib.Goose = function() {
	this.initialize(img.MainAssets_Goose);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,136,185);


(lib.Goose_ClosedEyes = function() {
	this.initialize(img.MainAssets_Goose_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,137,185);


(lib.Grass = function() {
	this.initialize(img.MainAssets_Grass);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,979,1586);


(lib.GreyBackground = function() {
	this.initialize(img.MainAssets_GreyBackground);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1334,2108);


(lib.HappyGambit = function() {
	this.initialize(img.MainAssets_HappyGambit);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,343,434);


(lib.Kabouter = function() {
	this.initialize(img.MainAssets_Kabouter);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,900,703);


(lib.Kid = function() {
	this.initialize(img.MainAssets_Kid);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,122,176);


(lib.Kid_ClosedEyes = function() {
	this.initialize(img.MainAssets_Kid_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,122,176);


(lib.Mill = function() {
	this.initialize(img.MainAssets_Mill);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1013,715);


(lib.Mother = function() {
	this.initialize(img.MainAssets_Mother);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,196,236);


(lib.Mother_ClosedEyes = function() {
	this.initialize(img.MainAssets_Mother_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,196,236);


(lib.PopupBG = function() {
	this.initialize(img.MainAssets_PopupBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1123,787);


(lib.PrevNextButton = function() {
	this.initialize(img.MainAssets_PrevNextButton);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.PrevNextButton_disabled = function() {
	this.initialize(img.MainAssets_PrevNextButton_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.PrevNextButton_down = function() {
	this.initialize(img.MainAssets_PrevNextButton_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.PullOutButton = function() {
	this.initialize(img.MainAssets_PullOutButton);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,265,162);


(lib.PullOutButton_disabled = function() {
	this.initialize(img.MainAssets_PullOutButton_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,205,85);


(lib.PullOutButton_down = function() {
	this.initialize(img.MainAssets_PullOutButton_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,205,84);


(lib.PullOutMenu = function() {
	this.initialize(img.MainAssets_PullOutMenu);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1125,1604);


(lib.River = function() {
	this.initialize(img.MainAssets_River);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1334,1242);


(lib.RiverbankDown = function() {
	this.initialize(img.MainAssets_RiverbankDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,726,444);


(lib.RiverbankUp = function() {
	this.initialize(img.MainAssets_RiverbankUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,726,444);


(lib.SackGrain = function() {
	this.initialize(img.MainAssets_SackGrain);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,152,205);


(lib.Skip_disabled = function() {
	this.initialize(img.MainAssets_Skip_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,210,179);


(lib.Skip_down = function() {
	this.initialize(img.MainAssets_Skip_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,210,179);


(lib.Skip_up = function() {
	this.initialize(img.MainAssets_Skip_up);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,210,179);


(lib.SlotArea = function() {
	this.initialize(img.MainAssets_SlotArea);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,201,117);


(lib.Snail = function() {
	this.initialize(img.MainAssets_Snail);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,178,243);


(lib.Snail_ClosedEyes = function() {
	this.initialize(img.MainAssets_Snail_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,177,243);


(lib.Spider = function() {
	this.initialize(img.MainAssets_Spider);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,207,224);


(lib.Spider_ClosedEyes = function() {
	this.initialize(img.MainAssets_Spider_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,207,224);


(lib.TopbarHUD = function() {
	this.initialize(img.MainAssets_TopbarHUD);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1334,159);


(lib.Tree = function() {
	this.initialize(img.MainAssets_Tree);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1013,778);


(lib.TutStep1 = function() {
	this.initialize(img.MainAssets_TutStep1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,898,330);


(lib.TutStep2 = function() {
	this.initialize(img.MainAssets_TutStep2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,754,292);


(lib.TutStep3 = function() {
	this.initialize(img.MainAssets_TutStep3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,823,336);


(lib.TutStep4 = function() {
	this.initialize(img.MainAssets_TutStep4);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,938,435);


(lib.TutStep5 = function() {
	this.initialize(img.MainAssets_TutStep5);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,939,641);


(lib.TutStep7 = function() {
	this.initialize(img.MainAssets_TutStep7);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,983,571);


(lib.Wolf = function() {
	this.initialize(img.MainAssets_Wolf);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,240,252);


(lib.Wolf_ClosedEyes = function() {
	this.initialize(img.MainAssets_Wolf_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,240,252);


(lib.Worm = function() {
	this.initialize(img.MainAssets_Worm);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,158,164);


(lib.Worm_ClosedEyes = function() {
	this.initialize(img.MainAssets_Worm_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,158,164);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.TutStep6 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TutStep7();
	this.instance.setTransform(0,0,0.7054,0.7054);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutStep6, new cjs.Rectangle(0,0,693.4,402.8), null);


(lib.TutStep5_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TutStep5();
	this.instance.setTransform(26,18,0.6496,0.7301);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutStep5_1, new cjs.Rectangle(26,18,610,468), null);


(lib.TutStep4_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TutStep4();
	this.instance.setTransform(0,0,0.7054,0.7054);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutStep4_1, new cjs.Rectangle(0,0,661.7,306.9), null);


(lib.TutStep3_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TutStep3();
	this.instance.setTransform(0,0,0.7054,0.7054);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutStep3_1, new cjs.Rectangle(0,0,580.5,237), null);


(lib.TutStep2_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TutStep2();
	this.instance.setTransform(0,0,0.7054,0.7054);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutStep2_1, new cjs.Rectangle(0,0,531.9,206), null);


(lib.TutStep1_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TutStep1();
	this.instance.setTransform(0,0,0.7054,0.7054);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutStep1_1, new cjs.Rectangle(0,0,633.4,232.8), null);


(lib.RulesEats = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.textfield = new cjs.Text("xeats", "40px 'Roboto Medium'", "#333333");
	this.textfield.name = "textfield";
	this.textfield.textAlign = "center";
	this.textfield.lineHeight = 48;
	this.textfield.lineWidth = 380;
	this.textfield.parent = this;
	this.textfield.setTransform(-1.6049,-31.1005);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RulesEats, new cjs.Rectangle(-193.4,-33.1,383.6,52), null);


(lib.RulesActorName = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.textfield = new cjs.Text("xactorname", "29px 'Roboto Medium'", "#333333");
	this.textfield.name = "textfield";
	this.textfield.textAlign = "center";
	this.textfield.lineHeight = 35;
	this.textfield.lineWidth = 274;
	this.textfield.parent = this;
	this.textfield.setTransform(-1,-23.7);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RulesActorName, new cjs.Rectangle(-140.1,-25.7,278.2,38.8), null);


(lib.RiverbankUp_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.RiverbankUp();
	this.instance.setTransform(0,0,1.8361,1.836);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RiverbankUp_1, new cjs.Rectangle(0,0,1333,815.2), null);


(lib.RiverbankDown_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.RiverbankDown();
	this.instance.setTransform(0,0,1.8361,1.836);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RiverbankDown_1, new cjs.Rectangle(0,0,1333,815.2), null);


(lib.PopupHappyGambit = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.HappyGambit();
	this.instance.setTransform(-280,-354,0.8163,0.8164);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PopupHappyGambit, new cjs.Rectangle(-280,-354,280,354.3), null);


(lib.PlaceholderRound = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.isSingleFrame = false;
	// timeline functions:
	this.frame_0 = function() {
		if(this.isSingleFrame) {
			return;
		}
		if(this.totalFrames == 1) {
			this.isSingleFrame = true;
		}
		this.removeChildAt(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgTAUQgHgJgBgLQABgKAHgJQAJgHAKgBQALABAJAHQAHAJABAKQgBALgHAJQgJAHgLABQgKgBgJgHg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlaceholderRound, new cjs.Rectangle(-2.7,-2.7,5.5,5.5), null);


(lib.Overlay = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(47,47,47,0)").ss(4,2,1).p("EhR6iJVMCj1AAAQCCAAAACCMAAAEOnQAACCiCAAMij1AAAQiCAAAAiCMAAAkOnQAAiCCCAAg");
	this.shape.setTransform(673.4667,1052.4837,1.2534,1.1974);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("EhR6CJWQiCAAAAiCMAAAkOnQAAiCCCAAMCj1AAAQCCAAAACCMAAAEOnQAACCiCAAg");
	this.shape_1.setTransform(673.4667,1052.4837,1.2534,1.1974);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Overlay, new cjs.Rectangle(-2,-2,1351,2109), null);


(lib.LevelDecoration = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {mill:0,tree:1,kabouter:2,euromast:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(4));

	// Layer_1
	this.instance = new lib.Mill();
	this.instance.setTransform(-506.5,-357.5);

	this.instance_1 = new lib.Tree();
	this.instance_1.setTransform(-506.5,-357.5);

	this.instance_2 = new lib.Kabouter();
	this.instance_2.setTransform(-456,-312);

	this.instance_3 = new lib.Euromast();
	this.instance_3.setTransform(-386,-426);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-506.5,-426,1013,846.5);


(lib.Hud = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.movesLabelTextfield = new cjs.Text("Moves:", "14px 'Roboto Medium'", "#FFFFFF");
	this.movesLabelTextfield.name = "movesLabelTextfield";
	this.movesLabelTextfield.textAlign = "center";
	this.movesLabelTextfield.lineHeight = 18;
	this.movesLabelTextfield.lineWidth = 97;
	this.movesLabelTextfield.parent = this;
	this.movesLabelTextfield.setTransform(0.6,-22.15);
ranj.TextOffsetFixer.fix(this.movesLabelTextfield);

	this.movesTextfield = new cjs.Text("1", "22px 'Roboto Medium'", "#FFFFFF");
	this.movesTextfield.name = "movesTextfield";
	this.movesTextfield.textAlign = "center";
	this.movesTextfield.lineHeight = 27;
	this.movesTextfield.lineWidth = 97;
	this.movesTextfield.parent = this;
	this.movesTextfield.setTransform(0.6,-5.15);
ranj.TextOffsetFixer.fix(this.movesTextfield);

	this.levelLabelTextfield = new cjs.Text("Level", "14px 'Roboto Medium'", "#FFFFFF");
	this.levelLabelTextfield.name = "levelLabelTextfield";
	this.levelLabelTextfield.textAlign = "center";
	this.levelLabelTextfield.lineHeight = 18;
	this.levelLabelTextfield.lineWidth = 97;
	this.levelLabelTextfield.parent = this;
	this.levelLabelTextfield.setTransform(-116.15,-22.15);
ranj.TextOffsetFixer.fix(this.levelLabelTextfield);

	this.levelTextfield = new cjs.Text("1", "22px 'Roboto Medium'", "#FFFFFF");
	this.levelTextfield.name = "levelTextfield";
	this.levelTextfield.textAlign = "center";
	this.levelTextfield.lineHeight = 27;
	this.levelTextfield.lineWidth = 97;
	this.levelTextfield.parent = this;
	this.levelTextfield.setTransform(-116.25,-5.15);
ranj.TextOffsetFixer.fix(this.levelTextfield);

	this.timeLabelTextfield = new cjs.Text("Elapsed time:", "14px 'Roboto Medium'", "#FFFFFF");
	this.timeLabelTextfield.name = "timeLabelTextfield";
	this.timeLabelTextfield.textAlign = "center";
	this.timeLabelTextfield.lineHeight = 18;
	this.timeLabelTextfield.lineWidth = 97;
	this.timeLabelTextfield.parent = this;
	this.timeLabelTextfield.setTransform(119.4,-22.15);
ranj.TextOffsetFixer.fix(this.timeLabelTextfield);

	this.timeTextfield = new cjs.Text("00:31", "22px 'Roboto Medium'", "#FFFFFF");
	this.timeTextfield.name = "timeTextfield";
	this.timeTextfield.textAlign = "center";
	this.timeTextfield.lineHeight = 27;
	this.timeTextfield.lineWidth = 97;
	this.timeTextfield.parent = this;
	this.timeTextfield.setTransform(119.7,-5.15);
ranj.TextOffsetFixer.fix(this.timeTextfield);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.timeTextfield},{t:this.timeLabelTextfield},{t:this.levelTextfield},{t:this.levelLabelTextfield},{t:this.movesTextfield},{t:this.movesLabelTextfield}]}).wait(1));

	// Layer_2
	this.instance = new lib.TopbarHUD();
	this.instance.setTransform(-255,-31,0.3748,0.3749);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Hud, new cjs.Rectangle(-255,-31,500,66.6), null);


(lib.GateKeeperScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.gatekeeper();
	this.instance.setTransform(0,0,0.6204,0.6204);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GateKeeperScreen, new cjs.Rectangle(0,0,836.9,1322), null);


(lib.GameScreenBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.GreyBackground();
	this.instance.setTransform(-667,-1054);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GameScreenBackground, new cjs.Rectangle(-667,-1054,1334,2108), null);


(lib.ArrowButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3,selectedUp:4,selectedOver:5,selectedDown:6,selectedDisabled:7};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Arrow();
	this.instance.setTransform(-25,-15);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4).to({rotation:180,x:25,y:15},0).wait(4));

	// Layer_2
	this.instance_1 = new lib.PullOutButton();
	this.instance_1.setTransform(-100,-55,0.7547,0.7545);

	this.instance_2 = new lib.PullOutButton_down();
	this.instance_2.setTransform(-78,-30,0.7561,0.7567);

	this.instance_3 = new lib.PullOutButton_disabled();
	this.instance_3.setTransform(-78,-30,0.7561,0.7567);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-100,-55,200,122.3);


(lib.Fish_02_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish_02();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish_02_1, new cjs.Rectangle(0,0,82,62), null);


(lib.Fish_01_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish_01();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish_01_1, new cjs.Rectangle(0,0,72,55), null);


(lib.DummyTutorialStepPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("A9NvnMA6bAAAQCCAAAACCIAAbLQAACCiCAAMg6bAAAQiCAAAAiCIAA7LQAAiCCCAAg");
	this.shape.setTransform(0.1091,0,0.8104,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(0,0,0,0.549)").s().p("A9NPoQiCAAAAiCIAA7LQAAiCCCAAMA6bAAAQCCAAAACCIAAbLQAACCiCAAg");
	this.shape_1.setTransform(0.1091,0,0.8104,1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DummyTutorialStepPanel, new cjs.Rectangle(-162.9,-101,326.1,202), null);


(lib.CharacterShadow_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.CharacterShadow();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.CharacterShadow_1, new cjs.Rectangle(0,0,294,163), null);


(lib.BoatSeat = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.SlotArea();
	this.instance.setTransform(-36,-20,0.3582,0.3582);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BoatSeat, new cjs.Rectangle(-36,-20,72,41.9), null);


(lib.Boat2Hitarea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#CC6633").s().p("AlRCIIlSlBIgxilIGhENIBrA8IE6B8IFNAGIEVhCIjgD4IlyA8g");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-72.4,-35.1,144.9,70.2);


(lib.Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Background_Blue();
	this.instance.setTransform(-666,-1054,1.3643,1.0273);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Background, new cjs.Rectangle(-667.4,-1055,1334.9,2110), null);


(lib.TutorialButtonHitarea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("ApkC3IAAltITJAAIAAFtg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialButtonHitarea, new cjs.Rectangle(-61.2,-18.2,122.5,36.5), null);


(lib.FeedbackPopupBG_Right = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackPopup_Right();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG_Right, new cjs.Rectangle(0,0,50,75), null);


(lib.FeedbackPopupBG_Middle = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackPopup_Middle();
	this.instance.setTransform(-2,0,1.0482,1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG_Middle, new cjs.Rectangle(-2,0,132.1,75), null);


(lib.FeedbackPopupBG_Left = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackPopup_Left();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG_Left, new cjs.Rectangle(0,0,50,75), null);


(lib.StartTutorialButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text Up
	this.upLabelTextField = new cjs.Text("Start", "19px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 23;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-0.3,-13.8);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Start", "19px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 23;
	this.overLabelTextField.lineWidth = 146;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-0.3,-13.8);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("Start", "19px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 23;
	this.downLabelTextField.lineWidth = 146;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-0.3,-13.8);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Start", "19px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 23;
	this.disabledLabelTextField.lineWidth = 146;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-0.3,-13.8);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.Button_up();
	this.instance.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_1 = new lib.Button_down();
	this.instance_1.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_2 = new lib.Button_disabled();
	this.instance_2.setTransform(-86.6,-30.9,0.4,0.3999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-86.6,-30.9,173.2,68);


(lib.StartGameButton_Overlay = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Start", "16px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 19;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0.05,-11.25);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Start", "16px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 19;
	this.overLabelTextField.lineWidth = 146;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0.05,-11.25);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Start", "16px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 19;
	this.downLabelTextField.lineWidth = 146;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0.05,-11.25);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Start", "16px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 19;
	this.disabledLabelTextField.lineWidth = 146;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0.05,-11.25);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.Button_up();
	this.instance.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_1 = new lib.Button_down();
	this.instance_1.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_2 = new lib.Button_disabled();
	this.instance_2.setTransform(-86.6,-30.9,0.4,0.3999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-86.6,-30.9,173.2,68);


(lib.StartGameButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text Up
	this.upLabelTextField = new cjs.Text("Start", "23px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 28;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0.5,-15.3);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Start", "23px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 28;
	this.overLabelTextField.lineWidth = 146;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0.5,-15.3);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("Start", "23px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 28;
	this.downLabelTextField.lineWidth = 146;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0.5,-15.3);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Start", "23px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 28;
	this.disabledLabelTextField.lineWidth = 146;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0.5,-15.3);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.Button_up();
	this.instance.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_1 = new lib.Button_down();
	this.instance_1.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_2 = new lib.Button_disabled();
	this.instance_2.setTransform(-86.6,-30.9,0.4,0.3999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-86.6,-30.9,173.2,68);


(lib.SkipButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Button
	this.instance = new lib.Skip_up();
	this.instance.setTransform(-28,-19,0.2619,0.2617);

	this.instance_1 = new lib.Skip_down();
	this.instance_1.setTransform(-28,-19,0.2619,0.2617);

	this.instance_2 = new lib.Skip_disabled();
	this.instance_2.setTransform(-28,-19,0.2619,0.2617);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-28,-19,55,46.9);


(lib.TutorialStep7 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.actionTextfield = new cjs.Text("Press to continue", "italic 38px 'Roboto'", "#CCCCCC");
	this.actionTextfield.name = "actionTextfield";
	this.actionTextfield.textAlign = "right";
	this.actionTextfield.lineHeight = 46;
	this.actionTextfield.lineWidth = 568;
	this.actionTextfield.parent = this;
	this.actionTextfield.setTransform(230.1,280.4979);
ranj.TextOffsetFixer.fix(this.actionTextfield);

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#262324").ss(4,1,1).p("AoXqZIQuAAQCCAAAACCIAAQuQAACCiCAAIwuAAQiCAAAAiCIAAwuQAAiCCCAAg");
	this.shape.setTransform(398.45,-179.6);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(47,47,47,0)").s().p("AoWKZQiDAAAAiBIAAwuQAAiDCDAAIQuAAQCBAAAACDIAAQuQAACBiBAAg");
	this.shape_1.setTransform(398.45,-179.6);

	this.bodyTextfield = new cjs.Text("This button will appear after a while.\n\nYou can click this button if you want to skip the level you are in and move on to the next one.", "40px 'Roboto Medium'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 48;
	this.bodyTextfield.lineWidth = 563;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-332.95,-98.353);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f().s("#262324").ss(4,1,1).p("EAAAhFAMAAACKB");
	this.shape_2.setTransform(401.35,-42.5044,1,0.1551);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f().s("#262324").ss(4,2,1).p("ASXAAMgktAAA");
	this.shape_3.setTransform(339.6538,26.6,0.525,1);

	this.instance = new lib.TutStep5_1();
	this.instance.setTransform(-40.9,0.15,1.067,1.067,0,0,0,339.4,153.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.shape_3},{t:this.shape_2},{t:this.bodyTextfield},{t:this.shape_1},{t:this.shape},{t:this.actionTextfield}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep7, new cjs.Rectangle(-375.2,-248.1,842.2,603.3), null);


(lib.TutorialStep6 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.actionTextfield = new cjs.Text("Press to continue", "italic 38px 'Roboto'", "#CCCCCC");
	this.actionTextfield.name = "actionTextfield";
	this.actionTextfield.textAlign = "right";
	this.actionTextfield.lineHeight = 46;
	this.actionTextfield.lineWidth = 477;
	this.actionTextfield.parent = this;
	this.actionTextfield.setTransform(211.4,222.4979);
ranj.TextOffsetFixer.fix(this.actionTextfield);

	this.bodyTextfield = new cjs.Text("The time you spend in a level is measured, but there is no limit.", "40px 'Roboto Medium'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 48;
	this.bodyTextfield.lineWidth = 460;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-248.4,19.5975);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(4,1,1).p("EAAAhFAMAAACKB");
	this.shape.setTransform(16.55,-195.7121,1,0.1112);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#262324").ss(4,1,1).p("EAAAhFAMAAACKB");
	this.shape_1.setTransform(16.55,-89.6176,1,0.1535);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f().s("#FFFFFF").ss(4,1,1).p("ASXAAMgktAAA");
	this.shape_2.setTransform(49.5868,-244.85,0.2715,1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f().s("#FFFFFF").ss(4,1,1).p("AuTqZIcoAAQCCAAAACCIAAQuQAACCiCAAI8oAAQiCAAAAiCIAAwuQAAiCCCAAg");
	this.shape_3.setTransform(186.15,-232.35);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("rgba(47,47,47,0)").s().p("AuTKZQiDAAAAiBIAAwuQAAiDCDAAIcnAAQCDAAAACDIAAQuQAACBiDAAg");
	this.shape_4.setTransform(186.15,-232.35);

	this.instance = new lib.TutStep6();
	this.instance.setTransform(-15.05,138.65,0.7954,0.7954,0,0,0,346.7,201.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape},{t:this.bodyTextfield},{t:this.actionTextfield}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep6, new cjs.Rectangle(-290.8,-300.9,583.6,599.8), null);


(lib.TutorialStep5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.actionTextfield = new cjs.Text("Press to continue", "italic 38px 'Roboto'", "#CCCCCC");
	this.actionTextfield.name = "actionTextfield";
	this.actionTextfield.textAlign = "right";
	this.actionTextfield.lineHeight = 46;
	this.actionTextfield.lineWidth = 495;
	this.actionTextfield.parent = this;
	this.actionTextfield.setTransform(240.15,261.9979);
ranj.TextOffsetFixer.fix(this.actionTextfield);

	this.bodyTextfield = new cjs.Text("There are 6 levels.\n\nYou finish a level when all characters are on the other side.", "40px 'Roboto Medium'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 48;
	this.bodyTextfield.lineWidth = 476;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-236.3,-58.9021);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(4,1,1).p("EAAAhFAMAAACKB");
	this.shape.setTransform(10.75,-217.1621,1,0.1112,0,0,180);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#262324").ss(4,1,1).p("EAAAhFAMAAACKB");
	this.shape_1.setTransform(10.75,-146.8621,1,0.1112,0,0,180);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f().s("#FFFFFF").ss(4,1,1).p("ASXAAMgktAAA");
	this.shape_2.setTransform(-22.2868,-266.3,0.2715,1,0,0,180);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f().s("#FFFFFF").ss(4,1,1).p("AuTqZIcoAAQCCAAAACCIAAQuQAACCiCAAI8oAAQiCAAAAiCIAAwuQAAiCCCAAg");
	this.shape_3.setTransform(-158.85,-252.2);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("rgba(47,47,47,0)").s().p("AuTKZQiDAAAAiBIAAwuQAAiDCDAAIcnAAQCDAAAACDIAAQuQAACBiDAAg");
	this.shape_4.setTransform(-158.85,-252.2);

	this.instance = new lib.TutStep5_1();
	this.instance.setTransform(-0.05,95.95,0.9237,0.9237,0,0,0,331.1,226.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape},{t:this.bodyTextfield},{t:this.actionTextfield}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep5, new cjs.Rectangle(-281.9,-320.7,563.5,656.7), null);


(lib.TutorialStep4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.bodyTextfield = new cjs.Text("Try to keep the number of moves you make in a level to a minimum.", "40px 'Roboto Medium'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 48;
	this.bodyTextfield.lineWidth = 576;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-289.05,11.548);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.actionTextfield = new cjs.Text("Press to continue", "italic 38px 'Roboto'", "#CCCCCC");
	this.actionTextfield.name = "actionTextfield";
	this.actionTextfield.textAlign = "right";
	this.actionTextfield.lineHeight = 46;
	this.actionTextfield.lineWidth = 592;
	this.actionTextfield.parent = this;
	this.actionTextfield.setTransform(286.55,203.7479);
ranj.TextOffsetFixer.fix(this.actionTextfield);

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(4,1,1).p("EAAAhFAMAAACKB");
	this.shape.setTransform(-149.95,-175.7621,1,0.1112);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#262324").ss(4,1,1).p("EAAAhFAMAAACKB");
	this.shape_1.setTransform(-149.95,-77.5121,1,0.1112);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f().s("#FFFFFF").ss(4,1,1).p("ASXAAMgktAAA");
	this.shape_2.setTransform(-131.9051,-224.9,0.1404,1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f().s("#FFFFFF").ss(4,1,1).p("AzhqZMAnDAAAQCCAAAACCIAAQuQAACCiCAAMgnDAAAQiCAAAAiCIAAwuQAAiCCCAAg");
	this.shape_3.setTransform(24,-211.95);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("rgba(47,47,47,0)").s().p("AzhKZQiCAAAAiBIAAwuQAAiDCCAAMAnDAAAQCCAAAACDIAAQuQAACBiCAAg");
	this.shape_4.setTransform(24,-211.95);

	this.instance = new lib.TutStep4_1();
	this.instance.setTransform(-0.05,125,1,1,0,0,0,330.8,153.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape},{t:this.actionTextfield},{t:this.bodyTextfield}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep4, new cjs.Rectangle(-330.8,-280.5,661.6,559), null);


(lib.TutorialStep3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.bodyTextfield = new cjs.Text("Klik op een karakter in de boot om het van de boot te halen.", "40px 'Roboto Medium'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 48;
	this.bodyTextfield.lineWidth = 489;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-273.95,-169.852);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#262324").ss(4,1,1).p("EAAAhFAMAAACKB");
	this.shape.setTransform(108.3,175.2846,1,0.3388);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#262324").ss(4,2,1).p("ASXAAMgktAAA");
	this.shape_1.setTransform(136.5056,324.9,0.2402,1);

	this.instance = new lib.TutStep3_1();
	this.instance.setTransform(-28.3,-92.85,1,1,0,0,0,290.2,118.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.shape_1},{t:this.shape},{t:this.bodyTextfield}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep3, new cjs.Rectangle(-403,-511,1106.4,1764.3), null);


(lib.TutorialStep2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.bodyTextfield = new cjs.Text("Klik op deze knop om de rivier over te steken.", "40px 'Roboto Medium'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 48;
	this.bodyTextfield.lineWidth = 435;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-248.1,-107.15);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#262324").ss(4,1,1).p("AAAukIAAdJ");
	this.shape.setTransform(-350.7,34.1117,1,0.779);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#262324").ss(4,2,1).p("ASXAAMgktAAA");
	this.shape_1.setTransform(-322.4556,-38.55,0.2402,1,0,0,180);

	this.instance = new lib.TutStep2_1();
	this.instance.setTransform(-28.35,-44.95,1,1,0,0,0,265.9,103);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.shape_1},{t:this.shape},{t:this.bodyTextfield}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep2, new cjs.Rectangle(-352.7,-147.9,590.3,256.7), null);


(lib.TutorialStep1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.bodyTextfield = new cjs.Text("Klik op een karakter om het op de boot te zetten.", "40px 'Roboto Medium'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 48;
	this.bodyTextfield.lineWidth = 542;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-332.95,-443.0521);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#262324").ss(4,1,1).p("Af1AAMg/pAAA");
	this.shape.setTransform(209.8251,495,0.7028,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#262324").ss(4,1,1).p("EAAAhFAMAAACKB");
	this.shape_1.setTransform(355.95,53.225);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f().s("#262324").ss(4,2,1).p("ASXAAMgktAAA");
	this.shape_2.setTransform(305.77,-388.45,0.4271,1);

	this.instance = new lib.TutStep1_1();
	this.instance.setTransform(-61.15,-378.6,1,1,0,0,0,316.7,116.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.shape_2},{t:this.shape_1},{t:this.shape},{t:this.bodyTextfield}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep1, new cjs.Rectangle(-377.8,-495,735.8,992), null);


(lib.LevelWith6SlotsSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bank_from
	this.from5 = new lib.PlaceholderRound();
	this.from5.name = "from5";
	this.from5.setTransform(-211.3,655.45);

	this.from4 = new lib.PlaceholderRound();
	this.from4.name = "from4";
	this.from4.setTransform(-360.85,566.35);

	this.from3 = new lib.PlaceholderRound();
	this.from3.name = "from3";
	this.from3.setTransform(-508.75,479.15);

	this.from2 = new lib.PlaceholderRound();
	this.from2.name = "from2";
	this.from2.setTransform(-76.25,566.35);

	this.from1 = new lib.PlaceholderRound();
	this.from1.name = "from1";
	this.from1.setTransform(-221.95,479.15);

	this.from0 = new lib.PlaceholderRound();
	this.from0.name = "from0";
	this.from0.setTransform(-371.5,392.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.from0},{t:this.from1},{t:this.from2},{t:this.from3},{t:this.from4},{t:this.from5}]}).wait(1));

	// boat placeholder
	this.boatTo = new lib.PlaceholderRound();
	this.boatTo.name = "boatTo";
	this.boatTo.setTransform(-1.35,123.85);

	this.boatFrom = new lib.PlaceholderRound();
	this.boatFrom.name = "boatFrom";
	this.boatFrom.setTransform(-198.3,235.35,1,1,0,0,0,0.1,-0.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.boatFrom},{t:this.boatTo}]}).wait(1));

	// bank_to
	this.to5 = new lib.PlaceholderRound();
	this.to5.name = "to5";
	this.to5.setTransform(153.1,-301.45);

	this.to2 = new lib.PlaceholderRound();
	this.to2.name = "to2";
	this.to2.setTransform(299.55,-31.1,1,1,0,0,0,2,1);

	this.to0 = new lib.PlaceholderRound();
	this.to0.name = "to0";
	this.to0.setTransform(155.1,-118.8,1,1,0,0,0,2,1);

	this.to1 = new lib.PlaceholderRound();
	this.to1.name = "to1";
	this.to1.setTransform(6.15,-208.95);

	this.to3 = new lib.PlaceholderRound();
	this.to3.name = "to3";
	this.to3.setTransform(443.15,-125.3);

	this.to4 = new lib.PlaceholderRound();
	this.to4.name = "to4";
	this.to4.setTransform(292.05,-214.45);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.to4},{t:this.to3},{t:this.to1},{t:this.to0},{t:this.to2},{t:this.to5}]}).wait(1));

	// fish etc
	this.instance = new lib.Fish_02_1();
	this.instance.setTransform(219.2,387.65,1,1,0,0,0,41,31);

	this.instance_1 = new lib.Fish_01_1();
	this.instance_1.setTransform(399.8,276,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_2 = new lib.Fish_01_1();
	this.instance_2.setTransform(394.1,233.95,1,1,0,0,0,36,27.5);

	this.instance_3 = new lib.Fish_01_1();
	this.instance_3.setTransform(-456.7,0.7,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_4 = new lib.Fish_01_1();
	this.instance_4.setTransform(-416.35,-13.3,1,1,0,0,0,36,27.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// grass etc
	this.decoration = new lib.LevelDecoration();
	this.decoration.name = "decoration";
	this.decoration.setTransform(529.5,-424.5);

	this.instance_5 = new lib.SlotArea();
	this.instance_5.setTransform(-312,600);

	this.instance_6 = new lib.SlotArea();
	this.instance_6.setTransform(-458,512);

	this.instance_7 = new lib.SlotArea();
	this.instance_7.setTransform(-605,425);

	this.instance_8 = new lib.SlotArea();
	this.instance_8.setTransform(-179,513);

	this.instance_9 = new lib.SlotArea();
	this.instance_9.setTransform(-325,425);

	this.instance_10 = new lib.SlotArea();
	this.instance_10.setTransform(-472,338);

	this.instance_11 = new lib.SlotArea();
	this.instance_11.setTransform(343,-184);

	this.instance_12 = new lib.SlotArea();
	this.instance_12.setTransform(197,-272);

	this.instance_13 = new lib.SlotArea();
	this.instance_13.setTransform(52,-359);

	this.instance_14 = new lib.SlotArea();
	this.instance_14.setTransform(198,-90);

	this.instance_15 = new lib.SlotArea();
	this.instance_15.setTransform(52,-178);

	this.instance_16 = new lib.SlotArea();
	this.instance_16.setTransform(-93,-265);

	this.instance_17 = new lib.Grass();
	this.instance_17.setTransform(-506,-659);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.decoration}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelWith6SlotsSkin, new cjs.Rectangle(-605,-782,1641,1709), null);


(lib.LevelWith5SlotsSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bank_from
	this.from4 = new lib.PlaceholderRound();
	this.from4.name = "from4";
	this.from4.setTransform(-288.95,616.75);

	this.from3 = new lib.PlaceholderRound();
	this.from3.name = "from3";
	this.from3.setTransform(-428.8,530.3);

	this.from2 = new lib.PlaceholderRound();
	this.from2.name = "from2";
	this.from2.setTransform(-78.75,572);

	this.from1 = new lib.PlaceholderRound();
	this.from1.name = "from1";
	this.from1.setTransform(-226.2,481.45);

	this.from0 = new lib.PlaceholderRound();
	this.from0.name = "from0";
	this.from0.setTransform(-373.05,393.45);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.from0},{t:this.from1},{t:this.from2},{t:this.from3},{t:this.from4}]}).wait(1));

	// boat placeholder
	this.boatTo = new lib.PlaceholderRound();
	this.boatTo.name = "boatTo";
	this.boatTo.setTransform(-1.35,123.85);

	this.boatFrom = new lib.PlaceholderRound();
	this.boatFrom.name = "boatFrom";
	this.boatFrom.setTransform(-198.3,235.35,1,1,0,0,0,0.1,-0.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.boatFrom},{t:this.boatTo}]}).wait(1));

	// bank_to
	this.to2 = new lib.PlaceholderRound();
	this.to2.name = "to2";
	this.to2.setTransform(302.15,-28,1,1,0,0,0,2,1);

	this.to1 = new lib.PlaceholderRound();
	this.to1.name = "to1";
	this.to1.setTransform(147.35,-120.75,1,1,0,0,0,2,1);

	this.to0 = new lib.PlaceholderRound();
	this.to0.name = "to0";
	this.to0.setTransform(4.15,-206.75);

	this.to4 = new lib.PlaceholderRound();
	this.to4.name = "to4";
	this.to4.setTransform(360.85,-180.75);

	this.to3 = new lib.PlaceholderRound();
	this.to3.name = "to3";
	this.to3.setTransform(206.2,-267.75);

	this.instance = new lib.SlotArea();
	this.instance.setTransform(108,-321);

	this.instance_1 = new lib.SlotArea();
	this.instance_1.setTransform(198,-90);

	this.instance_2 = new lib.SlotArea();
	this.instance_2.setTransform(52,-178);

	this.instance_3 = new lib.SlotArea();
	this.instance_3.setTransform(260,-236);

	this.instance_4 = new lib.SlotArea();
	this.instance_4.setTransform(-93,-265);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance},{t:this.to3},{t:this.to4},{t:this.to0},{t:this.to1},{t:this.to2}]}).wait(1));

	// fish etc
	this.instance_5 = new lib.Fish_02_1();
	this.instance_5.setTransform(219.2,387.65,1,1,0,0,0,41,31);

	this.instance_6 = new lib.Fish_01_1();
	this.instance_6.setTransform(399.8,276,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_7 = new lib.Fish_01_1();
	this.instance_7.setTransform(394.1,233.95,1,1,0,0,0,36,27.5);

	this.instance_8 = new lib.Fish_01_1();
	this.instance_8.setTransform(-456.7,0.7,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_9 = new lib.Fish_01_1();
	this.instance_9.setTransform(-416.35,-13.3,1,1,0,0,0,36,27.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5}]}).wait(1));

	// grass etc
	this.decoration = new lib.LevelDecoration();
	this.decoration.name = "decoration";
	this.decoration.setTransform(529.5,-424.5);

	this.instance_10 = new lib.SlotArea();
	this.instance_10.setTransform(-528,473);

	this.instance_11 = new lib.SlotArea();
	this.instance_11.setTransform(-389,559);

	this.instance_12 = new lib.SlotArea();
	this.instance_12.setTransform(-179,513);

	this.instance_13 = new lib.SlotArea();
	this.instance_13.setTransform(-325,425);

	this.instance_14 = new lib.SlotArea();
	this.instance_14.setTransform(-472,338);

	this.instance_15 = new lib.Grass();
	this.instance_15.setTransform(-506,-659);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.decoration}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelWith5SlotsSkin, new cjs.Rectangle(-528,-782,1564,1709), null);


(lib.LevelWith4SlotsSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bank_from
	this.from3 = new lib.PlaceholderRound();
	this.from3.name = "from3";
	this.from3.setTransform(-294.85,610.2);

	this.from2 = new lib.PlaceholderRound();
	this.from2.name = "from2";
	this.from2.setTransform(-77.55,570.35);

	this.from1 = new lib.PlaceholderRound();
	this.from1.name = "from1";
	this.from1.setTransform(-224.7,481.9);

	this.from0 = new lib.PlaceholderRound();
	this.from0.name = "from0";
	this.from0.setTransform(-371.8,395.95);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.from0},{t:this.from1},{t:this.from2},{t:this.from3}]}).wait(1));

	// boat placeholder
	this.boatTo = new lib.PlaceholderRound();
	this.boatTo.name = "boatTo";
	this.boatTo.setTransform(-1.35,123.85);

	this.boatFrom = new lib.PlaceholderRound();
	this.boatFrom.name = "boatFrom";
	this.boatFrom.setTransform(-198.3,235.35,1,1,0,0,0,0.1,-0.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.boatFrom},{t:this.boatTo}]}).wait(1));

	// bank_to
	this.to2 = new lib.PlaceholderRound();
	this.to2.name = "to2";
	this.to2.setTransform(297.4,-33.6);

	this.to1 = new lib.PlaceholderRound();
	this.to1.name = "to1";
	this.to1.setTransform(151.3,-121.55);

	this.to0 = new lib.PlaceholderRound();
	this.to0.name = "to0";
	this.to0.setTransform(4.15,-205.5);

	this.to3 = new lib.PlaceholderRound();
	this.to3.name = "to3";
	this.to3.setTransform(363,-176.45,1,1,0,0,0,2,1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.to3},{t:this.to0},{t:this.to1},{t:this.to2}]}).wait(1));

	// fish etc
	this.instance = new lib.Fish_02_1();
	this.instance.setTransform(219.2,387.65,1,1,0,0,0,41,31);

	this.instance_1 = new lib.Fish_01_1();
	this.instance_1.setTransform(399.8,276,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_2 = new lib.Fish_01_1();
	this.instance_2.setTransform(394.1,233.95,1,1,0,0,0,36,27.5);

	this.instance_3 = new lib.Fish_01_1();
	this.instance_3.setTransform(-456.7,0.7,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_4 = new lib.Fish_01_1();
	this.instance_4.setTransform(-416.35,-13.3,1,1,0,0,0,36,27.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// grass etc
	this.decoration = new lib.LevelDecoration();
	this.decoration.name = "decoration";
	this.decoration.setTransform(529.5,-424.5);

	this.instance_5 = new lib.SlotArea();
	this.instance_5.setTransform(-397,554);

	this.instance_6 = new lib.SlotArea();
	this.instance_6.setTransform(-179,513);

	this.instance_7 = new lib.SlotArea();
	this.instance_7.setTransform(-325,425);

	this.instance_8 = new lib.SlotArea();
	this.instance_8.setTransform(-472,338);

	this.instance_9 = new lib.SlotArea();
	this.instance_9.setTransform(198,-90);

	this.instance_10 = new lib.SlotArea();
	this.instance_10.setTransform(52,-178);

	this.instance_11 = new lib.SlotArea();
	this.instance_11.setTransform(-95,-265);

	this.instance_12 = new lib.SlotArea();
	this.instance_12.setTransform(260,-236);

	this.instance_13 = new lib.Grass();
	this.instance_13.setTransform(-506,-659);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.decoration}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelWith4SlotsSkin, new cjs.Rectangle(-506,-782,1542,1709), null);


(lib.LevelWith3SlotsSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bank_from
	this.from2 = new lib.PlaceholderRound();
	this.from2.name = "from2";
	this.from2.setTransform(-56.5,585.05);

	this.from1 = new lib.PlaceholderRound();
	this.from1.name = "from1";
	this.from1.setTransform(-205.05,497.85);

	this.from0 = new lib.PlaceholderRound();
	this.from0.name = "from0";
	this.from0.setTransform(-352,411.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.from0},{t:this.from1},{t:this.from2}]}).wait(1));

	// boat placeholder
	this.boatTo = new lib.PlaceholderRound();
	this.boatTo.name = "boatTo";
	this.boatTo.setTransform(-1.35,123.85);

	this.boatFrom = new lib.PlaceholderRound();
	this.boatFrom.name = "boatFrom";
	this.boatFrom.setTransform(-103.05,299.8,1,1,0,0,0,0.1,-0.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.boatFrom},{t:this.boatTo}]}).wait(1));

	// bank_to
	this.to2 = new lib.PlaceholderRound();
	this.to2.name = "to2";
	this.to2.setTransform(338.25,-20.6,1,1,0,0,0,2,1);

	this.to1 = new lib.PlaceholderRound();
	this.to1.name = "to1";
	this.to1.setTransform(190.35,-107.45);

	this.to0 = new lib.PlaceholderRound();
	this.to0.name = "to0";
	this.to0.setTransform(42.95,-194.35);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.to0},{t:this.to1},{t:this.to2}]}).wait(1));

	// Slots
	this.instance = new lib.SlotArea();
	this.instance.setTransform(236,-77);

	this.instance_1 = new lib.SlotArea();
	this.instance_1.setTransform(90,-165);

	this.instance_2 = new lib.SlotArea();
	this.instance_2.setTransform(-57,-252);

	this.instance_3 = new lib.SlotArea();
	this.instance_3.setTransform(-158,525);

	this.instance_4 = new lib.SlotArea();
	this.instance_4.setTransform(-305,438);

	this.instance_5 = new lib.SlotArea();
	this.instance_5.setTransform(-452,352);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// fish etc
	this.instance_6 = new lib.Fish_02_1();
	this.instance_6.setTransform(219.2,387.65,1,1,0,0,0,41,31);

	this.instance_7 = new lib.Fish_01_1();
	this.instance_7.setTransform(399.8,276,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_8 = new lib.Fish_01_1();
	this.instance_8.setTransform(394.1,233.95,1,1,0,0,0,36,27.5);

	this.instance_9 = new lib.Fish_01_1();
	this.instance_9.setTransform(-456.7,0.7,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_10 = new lib.Fish_01_1();
	this.instance_10.setTransform(-416.35,-13.3,1,1,0,0,0,36,27.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6}]}).wait(1));

	// grass etc
	this.decoration = new lib.LevelDecoration();
	this.decoration.name = "decoration";
	this.decoration.setTransform(529.5,-424.5);

	this.instance_11 = new lib.Grass();
	this.instance_11.setTransform(-476,-599);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_11},{t:this.decoration}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelWith3SlotsSkin, new cjs.Rectangle(-666,-782,1702,1769), null);


(lib.LevelWith2SlotsSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bank_from
	this.from1 = new lib.PlaceholderRound();
	this.from1.name = "from1";
	this.from1.setTransform(-48.5,572.05);

	this.from0 = new lib.PlaceholderRound();
	this.from0.name = "from0";
	this.from0.setTransform(-197.05,484.85);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.from0},{t:this.from1}]}).wait(1));

	// boat placeholder
	this.boatTo = new lib.PlaceholderRound();
	this.boatTo.name = "boatTo";
	this.boatTo.setTransform(-1.35,123.85);

	this.boatFrom = new lib.PlaceholderRound();
	this.boatFrom.name = "boatFrom";
	this.boatFrom.setTransform(-103.05,299.8,1,1,0,0,0,0.1,-0.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.boatFrom},{t:this.boatTo}]}).wait(1));

	// bank_to
	this.to1 = new lib.PlaceholderRound();
	this.to1.name = "to1";
	this.to1.setTransform(190.35,-107.45);

	this.to0 = new lib.PlaceholderRound();
	this.to0.name = "to0";
	this.to0.setTransform(42.95,-194.35);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.to0},{t:this.to1}]}).wait(1));

	// Slots
	this.instance = new lib.SlotArea();
	this.instance.setTransform(90,-165);

	this.instance_1 = new lib.SlotArea();
	this.instance_1.setTransform(-57,-252);

	this.instance_2 = new lib.SlotArea();
	this.instance_2.setTransform(-150,512);

	this.instance_3 = new lib.SlotArea();
	this.instance_3.setTransform(-297,425);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// fish etc
	this.instance_4 = new lib.Fish_02_1();
	this.instance_4.setTransform(219.2,387.65,1,1,0,0,0,41,31);

	this.instance_5 = new lib.Fish_01_1();
	this.instance_5.setTransform(399.8,276,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_6 = new lib.Fish_01_1();
	this.instance_6.setTransform(394.1,233.95,1,1,0,0,0,36,27.5);

	this.instance_7 = new lib.Fish_01_1();
	this.instance_7.setTransform(-456.7,0.7,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_8 = new lib.Fish_01_1();
	this.instance_8.setTransform(-416.35,-13.3,1,1,0,0,0,36,27.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4}]}).wait(1));

	// grass etc
	this.decoration = new lib.LevelDecoration();
	this.decoration.name = "decoration";
	this.decoration.setTransform(529.5,-424.5);

	this.instance_9 = new lib.Grass();
	this.instance_9.setTransform(-476,-599);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_9},{t:this.decoration}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelWith2SlotsSkin, new cjs.Rectangle(-666,-782,1702,1769), null);


(lib.LevelWith1SlotSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// boat placeholder
	this.boatTo = new lib.PlaceholderRound();
	this.boatTo.name = "boatTo";
	this.boatTo.setTransform(-1.35,123.85);

	this.boatFrom = new lib.PlaceholderRound();
	this.boatFrom.name = "boatFrom";
	this.boatFrom.setTransform(-103.05,299.8,1,1,0,0,0,0.1,-0.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.boatFrom},{t:this.boatTo}]}).wait(1));

	// Slots
	this.to0 = new lib.PlaceholderRound();
	this.to0.name = "to0";
	this.to0.setTransform(42.95,-194.35);

	this.instance = new lib.SlotArea();
	this.instance.setTransform(-57,-252);

	this.from0 = new lib.PlaceholderRound();
	this.from0.name = "from0";
	this.from0.setTransform(-56.5,585.05);

	this.instance_1 = new lib.SlotArea();
	this.instance_1.setTransform(-158,525);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.from0},{t:this.instance},{t:this.to0}]}).wait(1));

	// fish etc
	this.instance_2 = new lib.Fish_02_1();
	this.instance_2.setTransform(219.2,387.65,1,1,0,0,0,41,31);

	this.instance_3 = new lib.Fish_01_1();
	this.instance_3.setTransform(399.8,276,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_4 = new lib.Fish_01_1();
	this.instance_4.setTransform(394.1,233.95,1,1,0,0,0,36,27.5);

	this.instance_5 = new lib.Fish_01_1();
	this.instance_5.setTransform(-456.7,0.7,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_6 = new lib.Fish_01_1();
	this.instance_6.setTransform(-416.35,-13.3,1,1,0,0,0,36,27.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2}]}).wait(1));

	// grass etc
	this.decoration = new lib.LevelDecoration();
	this.decoration.name = "decoration";
	this.decoration.setTransform(529.5,-424.5);

	this.instance_7 = new lib.Grass();
	this.instance_7.setTransform(-476,-599);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_7},{t:this.decoration}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelWith1SlotSkin, new cjs.Rectangle(-666,-782,1702,1769), null);


(lib.GatekeeperBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.GateKeeperScreen();
	this.instance.setTransform(418.4,661,1,1,0,0,0,418.4,661);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GatekeeperBackground, new cjs.Rectangle(0,0,836.9,1322), null);


(lib.FailurePopupActorSlot = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// img
	this.image = new lib.PlaceholderRound();
	this.image.name = "image";
	this.image.setTransform(0,12.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.image).wait(1));

	// text
	this.nameTextfield = new cjs.Text("whatsmyname", "30px 'Roboto Medium'", "#333333");
	this.nameTextfield.name = "nameTextfield";
	this.nameTextfield.textAlign = "center";
	this.nameTextfield.lineHeight = 36;
	this.nameTextfield.lineWidth = 246;
	this.nameTextfield.parent = this;
	this.nameTextfield.setTransform(-0.05,42.7);
ranj.TextOffsetFixer.fix(this.nameTextfield);

	this.timeline.addTween(cjs.Tween.get(this.nameTextfield).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FailurePopupActorSlot, new cjs.Rectangle(-125,-100.2,250,180.9), null);


(lib.Boat3Container = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.slot2 = new lib.PlaceholderRound();
	this.slot2.name = "slot2";
	this.slot2.setTransform(145,59.1);

	this.slot1 = new lib.PlaceholderRound();
	this.slot1.name = "slot1";
	this.slot1.setTransform(15.95,-16.5);

	this.slot0 = new lib.PlaceholderRound();
	this.slot0.name = "slot0";
	this.slot0.setTransform(-95,-81.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.slot0},{t:this.slot1},{t:this.slot2}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Boat3Container, new cjs.Rectangle(-97.7,-83.8,245.5,145.7), null);


(lib.Boat2Container = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.slot1 = new lib.PlaceholderRound();
	this.slot1.name = "slot1";
	this.slot1.setTransform(98.15,35.4);

	this.slot0 = new lib.PlaceholderRound();
	this.slot0.name = "slot0";
	this.slot0.setTransform(-50.95,-43.05);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.slot0},{t:this.slot1}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Boat2Container, new cjs.Rectangle(-53.7,-45.8,154.60000000000002,84), null);


(lib.WormSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {blink:1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Worm();
	this.instance.setTransform(-64,-120);

	this.instance_1 = new lib.Worm_ClosedEyes();
	this.instance_1.setTransform(-64,-120);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-120,294,201);


(lib.WomanSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Mother();
	this.instance.setTransform(-67,-219);

	this.instance_1 = new lib.Mother_ClosedEyes();
	this.instance_1.setTransform(-67,-219);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-219,294,300);


(lib.WolfSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Wolf();
	this.instance.setTransform(-95,-234);

	this.instance_1 = new lib.Wolf_ClosedEyes();
	this.instance_1.setTransform(-95,-234);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-234,294,315);


(lib.SpiderSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Spider();
	this.instance.setTransform(-87,-137,0.8333,0.8333);

	this.instance_1 = new lib.Spider_ClosedEyes();
	this.instance_1.setTransform(-87,-137,0.8333,0.8333);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-137,294,218);


(lib.SnailSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Snail();
	this.instance.setTransform(-82,-164,0.8989,0.8988);

	this.instance_1 = new lib.Snail_ClosedEyes();
	this.instance_1.setTransform(-82,-164,0.8989,0.8988);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-164,294,245);


(lib.ManSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Father();
	this.instance.setTransform(-69,-219);

	this.instance_1 = new lib.Father_ClosedEyes();
	this.instance_1.setTransform(-69,-219);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-219,294,300);


(lib.Kid3Skin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Kid();
	this.instance.setTransform(-49,-158);

	this.instance_1 = new lib.Kid_ClosedEyes();
	this.instance_1.setTransform(-49,-158);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-158,294,239);


(lib.GooseSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Goose();
	this.instance.setTransform(-59,-174);

	this.instance_1 = new lib.Goose_ClosedEyes();
	this.instance_1.setTransform(-60,-174);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-174,294,255);


(lib.GoatSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Goat();
	this.instance.setTransform(-95,-243);

	this.instance_1 = new lib.Goat_ClosedEyes();
	this.instance_1.setTransform(-95,-243);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-243,294,324);


(lib.GirlSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Girl();
	this.instance.setTransform(-68,-158);

	this.instance_1 = new lib.Girl_ClosedEyes();
	this.instance_1.setTransform(-68,-158);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-158,294,239);


(lib.FoxSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Fox();
	this.instance.setTransform(-88,-234);

	this.instance_1 = new lib.Fox_ClosedEyes();
	this.instance_1.setTransform(-88,-234);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-234,343,315);


(lib.FarmerSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Farmer();
	this.instance.setTransform(-106,-297);

	this.instance_1 = new lib.Farmer_ClosedEyes();
	this.instance_1.setTransform(-106,-297);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-297,294,378);


(lib.DogSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Dog();
	this.instance.setTransform(-81,-225);

	this.instance_1 = new lib.Dog_ClosedEyes();
	this.instance_1.setTransform(-81,-225);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-225,310,306);


(lib.ChickenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Chicken();
	this.instance.setTransform(-54,-188);

	this.instance_1 = new lib.Chicken__ClosedEyes();
	this.instance_1.setTransform(-54,-188);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-188,294,269);


(lib.CaterpillarSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Caterpillar();
	this.instance.setTransform(-88,-79);

	this.instance_1 = new lib.Caterpillar_ClosedEyes();
	this.instance_1.setTransform(-88,-79);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-82,294,163);


(lib.CarrotSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.isSingleFrame = false;
	// timeline functions:
	this.frame_0 = function() {
		if(this.isSingleFrame) {
			return;
		}
		if(this.totalFrames == 1) {
			this.isSingleFrame = true;
		}
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// Layer_1
	this.instance = new lib.Carrot();
	this.instance.setTransform(-75,-64);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_2
	this.instance_1 = new lib.CharacterShadow_1();
	this.instance_1.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.CarrotSkin, new cjs.Rectangle(-145,-82,294,163), null);


(lib.CabbageSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.isSingleFrame = false;
	// timeline functions:
	this.frame_0 = function() {
		if(this.isSingleFrame) {
			return;
		}
		if(this.totalFrames == 1) {
			this.isSingleFrame = true;
		}
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// Layer_1
	this.instance = new lib.Cabbage();
	this.instance.setTransform(-102,-112);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_2
	this.instance_1 = new lib.CharacterShadow_1();
	this.instance_1.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.CabbageSkin, new cjs.Rectangle(-145,-112,294,193), null);


(lib.BoySkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Boy();
	this.instance.setTransform(-52,-164);

	this.instance_1 = new lib.Boy_ClosedEyes();
	this.instance_1.setTransform(-52,-164);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Shadow
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-164,294,245);


(lib.Boat3SkinNoSeats = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// container
	this.container = new lib.Boat3Container();
	this.container.name = "container";
	this.container.setTransform(76.4,-76.85,1,1,0,0,0,-0.1,0);

	this.timeline.addTween(cjs.Tween.get(this.container).wait(10));

	// hitarea
	this.hit = new lib.Boat2Hitarea();
	this.hit.name = "hit";
	this.hit.setTransform(98.75,-55.55,3,3);
	this.hit.alpha = 0.0508;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(10));

	// graphic
	this.instance = new lib.Ferry();
	this.instance.setTransform(-243,-414);

	this.instance_1 = new lib.Ferry_ClosedEyes();
	this.instance_1.setTransform(-243,-414);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-243,-414,677,534);


(lib.Boat3Skin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// container
	this.container = new lib.Boat3Container();
	this.container.name = "container";
	this.container.setTransform(87.65,-75.45,1,1,0,0,0,-0.1,-0.1);

	this.timeline.addTween(cjs.Tween.get(this.container).wait(10));

	// seats
	this.instance = new lib.BoatSeat();
	this.instance.setTransform(231.65,-17.95,3,3);

	this.instance_1 = new lib.BoatSeat();
	this.instance_1.setTransform(105.85,-92.7,3,3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(10));

	// hitarea
	this.hit = new lib.Boat2Hitarea();
	this.hit.name = "hit";
	this.hit.setTransform(110.05,-54.15,3,3);
	this.hit.alpha = 0.0508;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(10));

	// graphic
	this.instance_2 = new lib.Ferry();
	this.instance_2.setTransform(-243,-414);

	this.instance_3 = new lib.Ferry_ClosedEyes();
	this.instance_3.setTransform(-243,-414);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_3}]},1).wait(9));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-243,-414,677,534);


(lib.Boat2SkinNoSeats = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// container
	this.container = new lib.Boat2Container();
	this.container.name = "container";
	this.container.setTransform(116.4,-52.85,1,1,0,0,0,-0.1,0);

	this.timeline.addTween(cjs.Tween.get(this.container).wait(10));

	// hitarea
	this.hit = new lib.Boat2Hitarea();
	this.hit.name = "hit";
	this.hit.setTransform(98.75,-55.55,3,3);
	this.hit.alpha = 0.0508;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(10));

	// graphic
	this.instance = new lib.Ferry();
	this.instance.setTransform(-243,-414);

	this.instance_1 = new lib.Ferry_ClosedEyes();
	this.instance_1.setTransform(-243,-414);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-243,-414,677,534);


(lib.Boat2Skin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// container
	this.container = new lib.Boat2Container();
	this.container.name = "container";
	this.container.setTransform(74.7,-81.35,1,1,0,0,0,-0.1,0);

	this.timeline.addTween(cjs.Tween.get(this.container).wait(10));

	// seats
	this.instance = new lib.BoatSeat();
	this.instance.setTransform(172.8,-45.8,3,3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(10));

	// hitarea
	this.hit = new lib.Boat2Hitarea();
	this.hit.name = "hit";
	this.hit.setTransform(97.05,-60.05,3,3);
	this.hit.alpha = 0.0508;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(10));

	// graphic
	this.instance_1 = new lib.Ferry();
	this.instance_1.setTransform(-243,-414);

	this.instance_2 = new lib.Ferry_ClosedEyes();
	this.instance_2.setTransform(-243,-414);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).wait(9));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-243,-414,677,534);


(lib.BagSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.isSingleFrame = false;
	// timeline functions:
	this.frame_0 = function() {
		if(this.isSingleFrame) {
			return;
		}
		if(this.totalFrames == 1) {
			this.isSingleFrame = true;
		}
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// Layer_1
	this.instance = new lib.SackGrain();
	this.instance.setTransform(-73,-173);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_2
	this.instance_1 = new lib.CharacterShadow_1();
	this.instance_1.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BagSkin, new cjs.Rectangle(-145,-173,294,254), null);


(lib.EndScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button
	this.button = new lib.StartGameButton();
	this.button.name = "button";
	this.button.setTransform(-19.25,691.35,2.7273,2.7273);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	// texts
	this.bodyTextfield = new cjs.Text("Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here ", "38px 'Roboto'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 55;
	this.bodyTextfield.lineWidth = 875;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-431.8,-578.4527,0.9999,0.9999);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.titleTextfield = new cjs.Text("Minigame", "108px 'Roboto Medium'", "#FFFFFF");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 130;
	this.titleTextfield.lineWidth = 867;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-431.8,-793.45);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.titleTextfield},{t:this.bodyTextfield}]}).wait(1));

	// bg
	this.instance = new lib.Foreground_Splash();
	this.instance.setTransform(-666,-1054);

	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bg},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EndScreenSkin, new cjs.Rectangle(-667.5,-1184.2,1746.9,2239.2), null);


(lib.FeedbackPopupBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.bgRight = new lib.FeedbackPopupBG_Right();
	this.bgRight.name = "bgRight";
	this.bgRight.setTransform(200.5,37.5,1,1,0,0,0,25,37.5);

	this.bgMid = new lib.FeedbackPopupBG_Middle();
	this.bgMid.name = "bgMid";
	this.bgMid.setTransform(113,37.5,1,1,0,0,0,63,37.5);

	this.bgLeft = new lib.FeedbackPopupBG_Left();
	this.bgLeft.name = "bgLeft";
	this.bgLeft.setTransform(25.5,37.5,1,1,0,0,0,25,37.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bgLeft},{t:this.bgMid},{t:this.bgRight}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG, new cjs.Rectangle(0.5,0,225,75), null);


(lib.ReplayButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Previous", "18px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 22;
	this.upLabelTextField.lineWidth = 73;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-56.45,-4.35);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Previous", "18px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 22;
	this.overLabelTextField.lineWidth = 73;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-56.45,-4.35);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Previous", "18px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 22;
	this.downLabelTextField.lineWidth = 73;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-56.45,-4.35);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Previous", "18px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 22;
	this.disabledLabelTextField.lineWidth = 73;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-56.45,-4.35);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.PrevNextButton();
	this.instance.setTransform(-64.55,25.45,0.5057,0.5057,180);

	this.instance_1 = new lib.PrevNextButton_down();
	this.instance_1.setTransform(-64.55,25.45,0.5062,0.5062,180);

	this.instance_2 = new lib.PrevNextButton_disabled();
	this.instance_2.setTransform(-64.55,25.45,0.5062,0.5062,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	// hitarea
	this.hit = new lib.TutorialButtonHitarea();
	this.hit.name = "hit";
	this.hit.setTransform(-40.75,0.3);
	this.hit.alpha = 0.0117;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-103,-17.9,123.5,43.4);


(lib.PrevButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 17;
	this.upLabelTextField.lineWidth = 73;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-56.45,-9.75);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 17;
	this.overLabelTextField.lineWidth = 73;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-56.45,-9.75);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 17;
	this.downLabelTextField.lineWidth = 73;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-56.45,-9.75);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 17;
	this.disabledLabelTextField.lineWidth = 73;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-56.45,-9.75);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.PrevNextButton();
	this.instance.setTransform(-66.45,15.15,0.3945,0.3945,180);

	this.instance_1 = new lib.PrevNextButton_down();
	this.instance_1.setTransform(-66.45,15.15,0.3945,0.3945,180);

	this.instance_2 = new lib.PrevNextButton_disabled();
	this.instance_2.setTransform(-66.45,15.15,0.3945,0.3945,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	// hitarea
	this.hit = new lib.TutorialButtonHitarea();
	this.hit.name = "hit";
	this.hit.setTransform(-40.75,0.3);
	this.hit.alpha = 0.0117;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-102,-17.9,122.5,36.5);


(lib.TutorialStep8 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.titleTextfield = new cjs.Text("Screen title", "74px 'Roboto Medium'", "#FFFFFF");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.textAlign = "center";
	this.titleTextfield.lineHeight = 89;
	this.titleTextfield.lineWidth = 619;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(0.15,-543.1021);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.bodyTextfield = new cjs.Text("• [Instructions]", "38px 'Roboto Medium'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 46;
	this.bodyTextfield.lineWidth = 619;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-309.25,-326.9521);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.replayButton = new lib.ReplayButton();
	this.replayButton.name = "replayButton";
	this.replayButton.setTransform(-240.05,554.55,2.1093,2.1093,0,0,0,-40.8,0.4);

	this.startButton = new lib.StartGameButton();
	this.startButton.name = "startButton";
	this.startButton.setTransform(182,569.25,2.4219,2.4219,0,0,0,0,3.5);

	this.instance = new lib.GatekeeperBackground();
	this.instance.setTransform(-1.05,-10.4,1,1,0,0,0,418.4,661);

	this.overlay = new lib.Overlay();
	this.overlay.name = "overlay";
	this.overlay.setTransform(-0.05,0.05,1.0218,1.0186,0,0,0,673.4,1052.5);
	this.overlay.alpha = 0.2813;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.overlay},{t:this.instance},{t:this.startButton},{t:this.replayButton},{t:this.bodyTextfield},{t:this.titleTextfield}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep8, new cjs.Rectangle(-690.8,-1074.7,1381.6999999999998,2149.5), null);


(lib.TutorialStep0 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.startButton = new lib.StartTutorialButton();
	this.startButton.name = "startButton";
	this.startButton.setTransform(-4.7,466.35,2.463,2.463);

	this.titleTextfield = new cjs.Text("Tijd om te oefenen", "74px 'Roboto Medium'", "#FFFFFF");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.textAlign = "center";
	this.titleTextfield.lineHeight = 89;
	this.titleTextfield.lineWidth = 673;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(0,-543.1021);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.bodyTextfield = new cjs.Text("• [Instructions]", "38px 'Roboto Medium'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 46;
	this.bodyTextfield.lineWidth = 619;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-309.25,-326.9521);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.instance = new lib.GatekeeperBackground();
	this.instance.setTransform(-0.05,-10.4,1,1,0,0,0,418.4,661);

	this.overlay = new lib.Overlay();
	this.overlay.name = "overlay";
	this.overlay.setTransform(-0.05,0.05,1.0218,1.0186,0,0,0,673.4,1052.5);
	this.overlay.alpha = 0.2813;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.overlay},{t:this.instance},{t:this.bodyTextfield},{t:this.titleTextfield},{t:this.startButton}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep0, new cjs.Rectangle(-690.8,-1074.7,1381.6999999999998,2149.5), null);


(lib.TutorialOverlaySkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text
	this.step0 = new lib.TutorialStep0();
	this.step0.name = "step0";
	this.step0.setTransform(-0.8,7.45);

	this.step1 = new lib.TutorialStep1();
	this.step1.name = "step1";
	this.step1.setTransform(-48.3,19.6,1,1,0,0,0,1.3,1);

	this.step2 = new lib.TutorialStep2();
	this.step2.name = "step2";
	this.step2.setTransform(219.7,571.85,1,1,0,0,0,1.3,1);

	this.step3 = new lib.TutorialStep3();
	this.step3.name = "step3";
	this.step3.setTransform(-150.1,-358.95,1,1,0,0,0,1.3,1);

	this.step4 = new lib.TutorialStep4();
	this.step4.name = "step4";
	this.step4.setTransform(-18.2,-551.6,1,1,0,0,0,-0.1,20.2);

	this.step5 = new lib.TutorialStep5();
	this.step5.name = "step5";
	this.step5.setTransform(-189.2,-524.75,1,1,0,0,0,0,6);

	this.step6 = new lib.TutorialStep6();
	this.step6.name = "step6";
	this.step6.setTransform(174.75,-535,1,1,0,0,0,1,17.2);

	this.step7 = new lib.TutorialStep7();
	this.step7.name = "step7";
	this.step7.setTransform(29.75,-411.6,1,1,0,0,0,1.4,-1.1);

	this.step8 = new lib.TutorialStep8();
	this.step8.name = "step8";
	this.step8.setTransform(1.25,9.45);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.step0}]}).to({state:[{t:this.step1}]},1).to({state:[{t:this.step2}]},1).to({state:[{t:this.step3}]},1).to({state:[{t:this.step4}]},1).to({state:[{t:this.step5}]},1).to({state:[{t:this.step6}]},1).to({state:[{t:this.step7}]},1).to({state:[{t:this.step8}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1653.3,-1180.2,2736.7,2264.4);


(lib.Popup = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {success:0,failure:1,skip:2};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text
	this.bodyTextfield = new cjs.Text("bodyTextfield\nline2", "40px 'Roboto Medium'", "#333333");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 58;
	this.bodyTextfield.lineWidth = 866;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(125.95,197.2);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.titleTextfield = new cjs.Text("titleTextfield", "50px 'Roboto Medium'", "#333333");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 61;
	this.titleTextfield.lineWidth = 872;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(125.95,102.9);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.titleTextfield},{t:this.bodyTextfield}]}).wait(3));

	// Images
	this.gambit = new lib.PopupHappyGambit();
	this.gambit.name = "gambit";
	this.gambit.setTransform(1071.95,729.4,0.8929,0.8927);

	this.slot1 = new lib.FailurePopupActorSlot();
	this.slot1.name = "slot1";
	this.slot1.setTransform(690.6,523.2,1,1,0,0,0,0.1,67.7);

	this.slot0 = new lib.FailurePopupActorSlot();
	this.slot0.name = "slot0";
	this.slot0.setTransform(441.9,523.2,1,1,0,0,0,0.1,67.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.gambit}]}).to({state:[{t:this.slot0},{t:this.slot1}]},1).to({state:[]},1).wait(1));

	// Buttons
	this.cancelButton = new lib.StartGameButton_Overlay();
	this.cancelButton.name = "cancelButton";
	this.cancelButton.setTransform(797.8,639.6,2.7291,2.7272,0,0,0,-0.2,2.7);

	this.continueButton = new lib.StartGameButton_Overlay();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(329.3,639.6,2.7291,2.7272,0,0,0,-0.2,2.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.continueButton},{t:this.cancelButton}]}).wait(3));

	// PopupBG
	this.instance = new lib.PopupBG();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(3));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1123,787);


(lib.LevelRules_wolfwolffoxchickenworm = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// actors
	this.actor4 = new lib.ChickenSkin();
	this.actor4.name = "actor4";
	this.actor4.setTransform(243.3,-85.95,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor5 = new lib.WormSkin();
	this.actor5.name = "actor5";
	this.actor5.setTransform(243.3,429.45,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor0 = new lib.ChickenSkin();
	this.actor0.name = "actor0";
	this.actor0.setTransform(-249.5,457.45,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor6 = new lib.ChickenSkin();
	this.actor6.name = "actor6";
	this.actor6.setTransform(243.3,186.75,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor1 = new lib.FoxSkin();
	this.actor1.name = "actor1";
	this.actor1.setTransform(-249.5,186.75,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor2 = new lib.WolfSkin();
	this.actor2.name = "actor2";
	this.actor2.setTransform(-249.5,-85.95,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor7 = new lib.FoxSkin();
	this.actor7.name = "actor7";
	this.actor7.setTransform(243.3,-357.65,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor3 = new lib.WolfSkin();
	this.actor3.name = "actor3";
	this.actor3.setTransform(-249.5,-357.65,0.65,0.65,0,0,0,-10.6,-29.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.actor3},{t:this.actor7},{t:this.actor2},{t:this.actor1},{t:this.actor6},{t:this.actor0},{t:this.actor5},{t:this.actor4}]}).wait(1));

	// text in movieclips
	this.actorName_worm = new lib.RulesActorName();
	this.actorName_worm.name = "actorName_worm";
	this.actorName_worm.setTransform(252.15,550.1);

	this.actorName_chicken = new lib.RulesActorName();
	this.actorName_chicken.name = "actorName_chicken";
	this.actorName_chicken.setTransform(-240.65,550.1);

	this.eat3 = new lib.RulesEats();
	this.eat3.name = "eat3";
	this.eat3.setTransform(1.6,451.7,1,1,0,0,0,1.6,-2);

	this.actorName_chicken_1 = new lib.RulesActorName();
	this.actorName_chicken_1.name = "actorName_chicken_1";
	this.actorName_chicken_1.setTransform(252.15,275.4);

	this.actorName_fox = new lib.RulesActorName();
	this.actorName_fox.name = "actorName_fox";
	this.actorName_fox.setTransform(-240.65,275.4);

	this.eat2 = new lib.RulesEats();
	this.eat2.name = "eat2";
	this.eat2.setTransform(1.6,177,1,1,0,0,0,1.6,-2);

	this.actorName_chicken_2 = new lib.RulesActorName();
	this.actorName_chicken_2.name = "actorName_chicken_2";
	this.actorName_chicken_2.setTransform(252.15,4.7);

	this.actorName_wolf = new lib.RulesActorName();
	this.actorName_wolf.name = "actorName_wolf";
	this.actorName_wolf.setTransform(-240.65,4.7);

	this.eat1 = new lib.RulesEats();
	this.eat1.name = "eat1";
	this.eat1.setTransform(1.6,-93.7,1,1,0,0,0,1.6,-2);

	this.actorName_fox_1 = new lib.RulesActorName();
	this.actorName_fox_1.name = "actorName_fox_1";
	this.actorName_fox_1.setTransform(252.15,-269.95);

	this.actorName_wolf_1 = new lib.RulesActorName();
	this.actorName_wolf_1.name = "actorName_wolf_1";
	this.actorName_wolf_1.setTransform(-240.65,-269.95);

	this.eat0 = new lib.RulesEats();
	this.eat0.name = "eat0";
	this.eat0.setTransform(1.6,-368.35,1,1,0,0,0,1.6,-2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.eat0},{t:this.actorName_wolf_1},{t:this.actorName_fox_1},{t:this.eat1},{t:this.actorName_wolf},{t:this.actorName_chicken_2},{t:this.eat2},{t:this.actorName_fox},{t:this.actorName_chicken_1},{t:this.eat3},{t:this.actorName_chicken},{t:this.actorName_worm}]}).wait(1));

	// texts
	this.text1 = new cjs.Text("xIf left unattended:", "40px 'Roboto Medium'", "#333333");
	this.text1.name = "text1";
	this.text1.textAlign = "center";
	this.text1.lineHeight = 48;
	this.text1.lineWidth = 877;
	this.text1.parent = this;
	this.text1.setTransform(28.0991,-582.4516);
ranj.TextOffsetFixer.fix(this.text1);

	this.timeline.addTween(cjs.Tween.get(this.text1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelRules_wolfwolffoxchickenworm, new cjs.Rectangle(-412.2,-584.4,880.7,1147.6), null);


(lib.LevelRules_wolfdogchickenworm = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// actors
	this.actor3 = new lib.DogSkin();
	this.actor3.name = "actor3";
	this.actor3.setTransform(-11.15,550.7,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor4 = new lib.WormSkin();
	this.actor4.name = "actor4";
	this.actor4.setTransform(243.3,67.45,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor0 = new lib.ChickenSkin();
	this.actor0.name = "actor0";
	this.actor0.setTransform(-249.5,93.45,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor5 = new lib.ChickenSkin();
	this.actor5.name = "actor5";
	this.actor5.setTransform(243.3,-179.25,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor1 = new lib.WolfSkin();
	this.actor1.name = "actor1";
	this.actor1.setTransform(-249.5,-179.25,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor6 = new lib.DogSkin();
	this.actor6.name = "actor6";
	this.actor6.setTransform(243.3,-450.95,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor2 = new lib.WolfSkin();
	this.actor2.name = "actor2";
	this.actor2.setTransform(-249.5,-450.95,0.65,0.65,0,0,0,-10.6,-29.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.actor2},{t:this.actor6},{t:this.actor1},{t:this.actor5},{t:this.actor0},{t:this.actor4},{t:this.actor3}]}).wait(1));

	// text in movieclips
	this.actorName_dog = new lib.RulesActorName();
	this.actorName_dog.name = "actorName_dog";
	this.actorName_dog.setTransform(-2.3,641.35);

	this.actorName_worm = new lib.RulesActorName();
	this.actorName_worm.name = "actorName_worm";
	this.actorName_worm.setTransform(252.15,181.4);

	this.actorName_chicken = new lib.RulesActorName();
	this.actorName_chicken.name = "actorName_chicken";
	this.actorName_chicken.setTransform(-240.65,181.4);

	this.eat2 = new lib.RulesEats();
	this.eat2.name = "eat2";
	this.eat2.setTransform(1.6,83,1,1,0,0,0,1.6,-2);

	this.actorName_chicken_1 = new lib.RulesActorName();
	this.actorName_chicken_1.name = "actorName_chicken_1";
	this.actorName_chicken_1.setTransform(252.15,-89.3);

	this.actorName_wolf = new lib.RulesActorName();
	this.actorName_wolf.name = "actorName_wolf";
	this.actorName_wolf.setTransform(-240.65,-89.3);

	this.eat1 = new lib.RulesEats();
	this.eat1.name = "eat1";
	this.eat1.setTransform(1.6,-187.7,1,1,0,0,0,1.6,-2);

	this.actorName_dog_1 = new lib.RulesActorName();
	this.actorName_dog_1.name = "actorName_dog_1";
	this.actorName_dog_1.setTransform(252.15,-359.95);

	this.actorName_wolf_1 = new lib.RulesActorName();
	this.actorName_wolf_1.name = "actorName_wolf_1";
	this.actorName_wolf_1.setTransform(-240.65,-359.95);

	this.eat0 = new lib.RulesEats();
	this.eat0.name = "eat0";
	this.eat0.setTransform(1.6,-462.35,1,1,0,0,0,1.6,-2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.eat0},{t:this.actorName_wolf_1},{t:this.actorName_dog_1},{t:this.eat1},{t:this.actorName_wolf},{t:this.actorName_chicken_1},{t:this.eat2},{t:this.actorName_chicken},{t:this.actorName_worm},{t:this.actorName_dog}]}).wait(1));

	// Layer_1
	this.text1 = new cjs.Text("xIf left unattended:", "40px 'Roboto Medium'", "#333333");
	this.text1.name = "text1";
	this.text1.textAlign = "center";
	this.text1.lineHeight = 48;
	this.text1.lineWidth = 877;
	this.text1.parent = this;
	this.text1.setTransform(-0.0509,-662.5016);
ranj.TextOffsetFixer.fix(this.text1);

	this.text2 = new cjs.Text("xThe dog protects the worm from being eaten.", "40px 'Roboto Medium'", "#333333");
	this.text2.name = "text2";
	this.text2.textAlign = "center";
	this.text2.lineHeight = 58;
	this.text2.lineWidth = 689;
	this.text2.parent = this;
	this.text2.setTransform(-14.3022,264.5495);
ranj.TextOffsetFixer.fix(this.text2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.text2},{t:this.text1}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelRules_wolfdogchickenworm, new cjs.Rectangle(-440.3,-664.5,880.6,1319), null);


(lib.LevelRules_foxchickenworm = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// actors 
	this.actor2 = new lib.FarmerSkin();
	this.actor2.name = "actor2";
	this.actor2.setTransform(-44.45,-435.25,0.55,0.55,0,0,0,-10.8,-29.6);

	this.instance = new lib.Ferry();
	this.instance.setTransform(-169,-560,0.5,0.5);

	this.actor3 = new lib.WormSkin();
	this.actor3.name = "actor3";
	this.actor3.setTransform(243.3,526.3,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor0 = new lib.ChickenSkin();
	this.actor0.name = "actor0";
	this.actor0.setTransform(-249.5,548.3,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor4 = new lib.ChickenSkin();
	this.actor4.name = "actor4";
	this.actor4.setTransform(243.3,275.6,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor1 = new lib.FoxSkin();
	this.actor1.name = "actor1";
	this.actor1.setTransform(-249.5,275.6,0.65,0.65,0,0,0,-10.6,-29.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.actor1},{t:this.actor4},{t:this.actor0},{t:this.actor3},{t:this.instance},{t:this.actor2}]}).wait(1));

	// actornames
	this.actorName_worm = new lib.RulesActorName();
	this.actorName_worm.name = "actorName_worm";
	this.actorName_worm.setTransform(252.15,638.95);

	this.actorName_chicken = new lib.RulesActorName();
	this.actorName_chicken.name = "actorName_chicken";
	this.actorName_chicken.setTransform(-240.65,638.95);

	this.actorName_chicken_1 = new lib.RulesActorName();
	this.actorName_chicken_1.name = "actorName_chicken_1";
	this.actorName_chicken_1.setTransform(252.15,366.25);

	this.actorName_fox = new lib.RulesActorName();
	this.actorName_fox.name = "actorName_fox";
	this.actorName_fox.setTransform(-240.65,366.25);

	this.actorName_farmer = new lib.RulesActorName();
	this.actorName_farmer.name = "actorName_farmer";
	this.actorName_farmer.setTransform(-5.65,-234.45);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.actorName_farmer},{t:this.actorName_fox},{t:this.actorName_chicken_1},{t:this.actorName_chicken},{t:this.actorName_worm}]}).wait(1));

	// Layer_1
	this.eat1 = new lib.RulesEats();
	this.eat1.name = "eat1";
	this.eat1.setTransform(1.6,538.75,1,1,0,0,0,1.6,-2);

	this.eat0 = new lib.RulesEats();
	this.eat0.name = "eat0";
	this.eat0.setTransform(1.6,267.85,1,1,0,0,0,1.6,-2);

	this.text2 = new cjs.Text("xIf left unattended:", "40px 'Roboto Medium'", "#333333");
	this.text2.name = "text2";
	this.text2.textAlign = "center";
	this.text2.lineHeight = 48;
	this.text2.lineWidth = 877;
	this.text2.parent = this;
	this.text2.setTransform(-1.9509,64.5484);
ranj.TextOffsetFixer.fix(this.text2);

	this.text1 = new cjs.Text("xThe farmer prevents characters from eating each other.", "40px 'Roboto Medium'", "#333333");
	this.text1.name = "text1";
	this.text1.textAlign = "center";
	this.text1.lineHeight = 58;
	this.text1.lineWidth = 879;
	this.text1.parent = this;
	this.text1.setTransform(-0.9509,-148.5505);
ranj.TextOffsetFixer.fix(this.text1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.text1},{t:this.text2},{t:this.eat0},{t:this.eat1}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelRules_foxchickenworm, new cjs.Rectangle(-442.2,-582.3,882.5999999999999,1234.4), null);


(lib.LevelRules_foxchickenspidercaterpillarcarrot = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// actors
	this.actor4 = new lib.CarrotSkin();
	this.actor4.name = "actor4";
	this.actor4.setTransform(243.3,427.45,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor0 = new lib.CaterpillarSkin();
	this.actor0.name = "actor0";
	this.actor0.setTransform(-249.5,435.45,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor5 = new lib.CaterpillarSkin();
	this.actor5.name = "actor5";
	this.actor5.setTransform(243.3,162.75,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor1 = new lib.SpiderSkin();
	this.actor1.name = "actor1";
	this.actor1.setTransform(-249.5,186.75,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor6 = new lib.SpiderSkin();
	this.actor6.name = "actor6";
	this.actor6.setTransform(243.3,-85.95,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor2 = new lib.ChickenSkin();
	this.actor2.name = "actor2";
	this.actor2.setTransform(-249.5,-85.95,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor7 = new lib.ChickenSkin();
	this.actor7.name = "actor7";
	this.actor7.setTransform(243.3,-357.65,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor3 = new lib.FoxSkin();
	this.actor3.name = "actor3";
	this.actor3.setTransform(-249.5,-357.65,0.65,0.65,0,0,0,-10.6,-29.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.actor3},{t:this.actor7},{t:this.actor2},{t:this.actor6},{t:this.actor1},{t:this.actor5},{t:this.actor0},{t:this.actor4}]}).wait(1));

	// text in movieclips
	this.actorName_carrot = new lib.RulesActorName();
	this.actorName_carrot.name = "actorName_carrot";
	this.actorName_carrot.setTransform(252.15,552.1);

	this.actorName_caterpillar = new lib.RulesActorName();
	this.actorName_caterpillar.name = "actorName_caterpillar";
	this.actorName_caterpillar.setTransform(-240.65,552.1);

	this.eat3 = new lib.RulesEats();
	this.eat3.name = "eat3";
	this.eat3.setTransform(1.6,453.7,1,1,0,0,0,1.6,-2);

	this.actorName_caterpillar_1 = new lib.RulesActorName();
	this.actorName_caterpillar_1.name = "actorName_caterpillar_1";
	this.actorName_caterpillar_1.setTransform(252.15,277.4);

	this.actorName_spider = new lib.RulesActorName();
	this.actorName_spider.name = "actorName_spider";
	this.actorName_spider.setTransform(-240.65,277.4);

	this.eat2 = new lib.RulesEats();
	this.eat2.name = "eat2";
	this.eat2.setTransform(1.6,179,1,1,0,0,0,1.6,-2);

	this.actorName_spider_1 = new lib.RulesActorName();
	this.actorName_spider_1.name = "actorName_spider_1";
	this.actorName_spider_1.setTransform(252.15,6.7);

	this.actorName_chicken = new lib.RulesActorName();
	this.actorName_chicken.name = "actorName_chicken";
	this.actorName_chicken.setTransform(-240.65,6.7);

	this.eat1 = new lib.RulesEats();
	this.eat1.name = "eat1";
	this.eat1.setTransform(1.6,-91.7,1,1,0,0,0,1.6,-2);

	this.actorName_chicken_1 = new lib.RulesActorName();
	this.actorName_chicken_1.name = "actorName_chicken_1";
	this.actorName_chicken_1.setTransform(252.15,-267.95);

	this.actorName_fox = new lib.RulesActorName();
	this.actorName_fox.name = "actorName_fox";
	this.actorName_fox.setTransform(-240.65,-267.95);

	this.eat0 = new lib.RulesEats();
	this.eat0.name = "eat0";
	this.eat0.setTransform(1.6,-366.35,1,1,0,0,0,1.6,-2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.eat0},{t:this.actorName_fox},{t:this.actorName_chicken_1},{t:this.eat1},{t:this.actorName_chicken},{t:this.actorName_spider_1},{t:this.eat2},{t:this.actorName_spider},{t:this.actorName_caterpillar_1},{t:this.eat3},{t:this.actorName_caterpillar},{t:this.actorName_carrot}]}).wait(1));

	// texts
	this.text1 = new cjs.Text("xIf left unattended:", "40px 'Roboto Medium'", "#333333");
	this.text1.name = "text1";
	this.text1.textAlign = "center";
	this.text1.lineHeight = 48;
	this.text1.lineWidth = 877;
	this.text1.parent = this;
	this.text1.setTransform(-0.0509,-572.5016);
ranj.TextOffsetFixer.fix(this.text1);

	this.timeline.addTween(cjs.Tween.get(this.text1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelRules_foxchickenspidercaterpillarcarrot, new cjs.Rectangle(-440.3,-574.5,880.6,1139.7), null);


(lib.LevelRules_familyOf5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// actors
	this.actor3 = new lib.Kid3Skin();
	this.actor3.name = "actor3";
	this.actor3.setTransform(101.5,135.75,0.7,0.7,0,0,0,0,-5.5);

	this.actor3_1 = new lib.BoySkin();
	this.actor3_1.name = "actor3_1";
	this.actor3_1.setTransform(212.3,139.95,0.7,0.7,0,0,0,0,-5.5);

	this.actor2 = new lib.WomanSkin();
	this.actor2.name = "actor2";
	this.actor2.setTransform(-1.4,509.9,0.7,0.7,0,0,0,0,-5.5);

	this.actor0 = new lib.GirlSkin();
	this.actor0.name = "actor0";
	this.actor0.setTransform(-167.45,135.3,0.7,0.7,0,0,0,0,-5.5);

	this.actor1 = new lib.BoySkin();
	this.actor1.name = "actor1";
	this.actor1.setTransform(-17.4,-266.9,0.5,0.5,0,0,0,0,-4.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.actor1},{t:this.actor0},{t:this.actor2},{t:this.actor3_1},{t:this.actor3}]}).wait(1));

	// bitmaps
	this.instance = new lib.Ferry();
	this.instance.setTransform(-169,-413,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// text in movieclips
	this.actorName_adult1 = new lib.RulesActorName();
	this.actorName_adult1.name = "actorName_adult1";
	this.actorName_adult1.setTransform(0.2,589.2);

	this.actorName_kid2 = new lib.RulesActorName();
	this.actorName_kid2.name = "actorName_kid2";
	this.actorName_kid2.setTransform(158.8,214.6);

	this.actorName_kid1 = new lib.RulesActorName();
	this.actorName_kid1.name = "actorName_kid1";
	this.actorName_kid1.setTransform(-167.25,214.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.actorName_kid1},{t:this.actorName_kid2},{t:this.actorName_adult1}]}).wait(1));

	// texts
	this.text3 = new cjs.Text("xOR", "40px 'Roboto Medium'", "#333333");
	this.text3.name = "text3";
	this.text3.textAlign = "center";
	this.text3.lineHeight = 48;
	this.text3.lineWidth = 875;
	this.text3.parent = this;
	this.text3.setTransform(-2.9509,280.6477);
ranj.TextOffsetFixer.fix(this.text3);

	this.text2 = new cjs.Text("xThe ferry can carry a maximum of:", "40px 'Roboto Medium'", "#333333");
	this.text2.name = "text2";
	this.text2.textAlign = "center";
	this.text2.lineHeight = 48;
	this.text2.lineWidth = 865;
	this.text2.parent = this;
	this.text2.setTransform(-7.9509,-87.5023);
ranj.TextOffsetFixer.fix(this.text2);

	this.text1 = new cjs.Text("xThe ferry can only cross when there is at least one person on it.", "40px 'Roboto Medium'", "#333333");
	this.text1.name = "text1";
	this.text1.textAlign = "center";
	this.text1.lineHeight = 58;
	this.text1.lineWidth = 881;
	this.text1.parent = this;
	this.text1.setTransform(0.0491,-604.8505);
ranj.TextOffsetFixer.fix(this.text1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.text1},{t:this.text2},{t:this.text3}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelRules_familyOf5, new cjs.Rectangle(-442.2,-606.8,884.5999999999999,1209.1), null);


(lib.LevelRules_familyOf4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// actors
	this.actor3 = new lib.BoySkin();
	this.actor3.name = "actor3";
	this.actor3.setTransform(212.3,139.5,0.7,0.7,0,0,0,0,-5.5);

	this.actor0 = new lib.GirlSkin();
	this.actor0.name = "actor0";
	this.actor0.setTransform(103.95,135.3,0.7,0.7,0,0,0,0,-5.5);

	this.actor2 = new lib.ManSkin();
	this.actor2.name = "actor2";
	this.actor2.setTransform(-1.4,509.9,0.7,0.7,0,0,0,0,-5.5);

	this.actor0_1 = new lib.GirlSkin();
	this.actor0_1.name = "actor0_1";
	this.actor0_1.setTransform(-167.45,135.3,0.7,0.7,0,0,0,0,-5.5);

	this.actor1 = new lib.BoySkin();
	this.actor1.name = "actor1";
	this.actor1.setTransform(-17.4,-266.9,0.5,0.5,0,0,0,0,-4.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.actor1},{t:this.actor0_1},{t:this.actor2},{t:this.actor0},{t:this.actor3}]}).wait(1));

	// bitmaps
	this.instance = new lib.Ferry();
	this.instance.setTransform(-169,-413,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// actorNames
	this.actorName_adult1 = new lib.RulesActorName();
	this.actorName_adult1.name = "actorName_adult1";
	this.actorName_adult1.setTransform(0.2,589.2);

	this.actorName_kid2 = new lib.RulesActorName();
	this.actorName_kid2.name = "actorName_kid2";
	this.actorName_kid2.setTransform(158.8,214.6);

	this.actorName_kid1 = new lib.RulesActorName();
	this.actorName_kid1.name = "actorName_kid1";
	this.actorName_kid1.setTransform(-167.25,214.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.actorName_kid1},{t:this.actorName_kid2},{t:this.actorName_adult1}]}).wait(1));

	// texts
	this.text3 = new cjs.Text("xOR", "40px 'Roboto Medium'", "#333333");
	this.text3.name = "text3";
	this.text3.textAlign = "center";
	this.text3.lineHeight = 48;
	this.text3.lineWidth = 875;
	this.text3.parent = this;
	this.text3.setTransform(-2.9509,280.6477);
ranj.TextOffsetFixer.fix(this.text3);

	this.text2 = new cjs.Text("xThe ferry can carry a maximum of:", "40px 'Roboto Medium'", "#333333");
	this.text2.name = "text2";
	this.text2.textAlign = "center";
	this.text2.lineHeight = 48;
	this.text2.lineWidth = 865;
	this.text2.parent = this;
	this.text2.setTransform(-7.9509,-87.5023);
ranj.TextOffsetFixer.fix(this.text2);

	this.text1 = new cjs.Text("xThe ferry can only cross when there is at least one person on it.", "40px 'Roboto Medium'", "#333333");
	this.text1.name = "text1";
	this.text1.textAlign = "center";
	this.text1.lineHeight = 58;
	this.text1.lineWidth = 881;
	this.text1.parent = this;
	this.text1.setTransform(0.0491,-604.8505);
ranj.TextOffsetFixer.fix(this.text1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.text1},{t:this.text2},{t:this.text3}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelRules_familyOf4, new cjs.Rectangle(-442.2,-606.8,884.5999999999999,1209.1), null);


(lib.GatekeeperOverlaySkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text
	this.startButton = new lib.StartGameButton();
	this.startButton.name = "startButton";
	this.startButton.setTransform(107.4,73.2,1,1,0,0,0,0,3.1);

	this.titleTextfield = new cjs.Text("[Title]", "28px 'Roboto Medium'", "#FFFFFF");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 34;
	this.titleTextfield.lineWidth = 382;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-195.95,-91.5021);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.replayButton = new lib.PrevButton();
	this.replayButton.name = "replayButton";
	this.replayButton.setTransform(-130.75,69.9,1,1,0,0,0,-40.8,0.3);

	this.bodyTextfield = new cjs.Text("• [Instructions]", "28px 'Roboto Medium'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 34;
	this.bodyTextfield.lineWidth = 382;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-195.95,-41.6521);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bodyTextfield},{t:this.replayButton},{t:this.titleTextfield},{t:this.startButton}]}).wait(1));

	// Panels
	this.panel = new lib.DummyTutorialStepPanel();
	this.panel.name = "panel";
	this.panel.setTransform(-6,2.45);

	this.timeline.addTween(cjs.Tween.get(this.panel).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GatekeeperOverlaySkin, new cjs.Rectangle(-663.5,-1180.2,1746.9,2239.2), null);


(lib.FeedbackPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// body
	this.bodyTextfield = new cjs.Text("abcdef ", "italic 40px 'Roboto'", "#333333");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.textAlign = "center";
	this.bodyTextfield.lineHeight = 49;
	this.bodyTextfield.lineWidth = 149;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-0.7498,9.8);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// Layer_2
	this.bg = new lib.FeedbackPopupBG();
	this.bg.name = "bg";
	this.bg.setTransform(-2,34.25,1,1,0,0,0,112,37.5);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPanel, new cjs.Rectangle(-113.5,-3.2,225,78.4), null);


(lib.RulesPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {familyOf4:0,foxchickenworm:1,wolfwolffoxchickenworm:2,wolfdogchickenworm:3,familyOf5:4,foxchickenspidercaterpillarcarrot:5};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// level contents
	this.level_familyOf4 = new lib.LevelRules_familyOf4();
	this.level_familyOf4.name = "level_familyOf4";
	this.level_familyOf4.setTransform(-30.7,686.95,1,1,0,0,0,-30.7,0);

	this.level_foxchickenworm = new lib.LevelRules_foxchickenworm();
	this.level_foxchickenworm.name = "level_foxchickenworm";
	this.level_foxchickenworm.setTransform(-36.1,630.5,1,1,0,0,0,-36.1,0);

	this.level_wolfwolffoxchickenworm = new lib.LevelRules_wolfwolffoxchickenworm();
	this.level_wolfwolffoxchickenworm.name = "level_wolfwolffoxchickenworm";
	this.level_wolfwolffoxchickenworm.setTransform(-36.1,645.85,1,1,0,0,0,-36.1,0);

	this.level_wolfdogchickenworm = new lib.LevelRules_wolfdogchickenworm();
	this.level_wolfdogchickenworm.name = "level_wolfdogchickenworm";
	this.level_wolfdogchickenworm.setTransform(-36.1,739.15,1,1,0,0,0,-36.1,0);

	this.level_familyOf5 = new lib.LevelRules_familyOf5();
	this.level_familyOf5.name = "level_familyOf5";
	this.level_familyOf5.setTransform(-30.7,686.95,1,1,0,0,0,-30.7,0);

	this.level_foxchickenspidercaterpillarcarrot = new lib.LevelRules_foxchickenspidercaterpillarcarrot();
	this.level_foxchickenspidercaterpillarcarrot.name = "level_foxchickenspidercaterpillarcarrot";
	this.level_foxchickenspidercaterpillarcarrot.setTransform(-36.1,645.85,1,1,0,0,0,-36.1,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.level_familyOf4}]}).to({state:[{t:this.level_foxchickenworm}]},1).to({state:[{t:this.level_wolfwolffoxchickenworm}]},1).to({state:[{t:this.level_wolfdogchickenworm}]},1).to({state:[{t:this.level_familyOf5}]},1).to({state:[{t:this.level_foxchickenspidercaterpillarcarrot}]},1).wait(1));

	// toggle
	this.toggle = new lib.ArrowButton();
	this.toggle.name = "toggle";
	this.toggle.setTransform(17.65,1490.9,1.35,1.3489,0,0,0,11,-0.2);

	this.timeline.addTween(cjs.Tween.get(this.toggle).wait(6));

	// bg
	this.instance = new lib.PullOutMenu();
	this.instance.setTransform(-560,1,0.9999,0.9999);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("EgHDBufImAx0MhCoAAAMAAAjLJMCfXAAAMAAADLJMg8CAAAImAR0g");
	this.shape.setTransform(4.3,707.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.instance}]}).wait(6));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-560,0,1125,1604.8);


(lib.RulesPanelContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// content (closed)
	this.contents = new lib.RulesPanel();
	this.contents.name = "contents";
	this.contents.setTransform(-6.65,-1434.15,1,1,0,0,0,0.5,-0.1);

	this.timeline.addTween(cjs.Tween.get(this.contents).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RulesPanelContainer, new cjs.Rectangle(-567.1,-1434,1124.9,3038.8), null);


(lib.GameScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// elements
	this.hud = new lib.Hud();
	this.hud.name = "hud";
	this.hud.setTransform(2.85,-781.1,3,3);

	this.timeline.addTween(cjs.Tween.get(this.hud).wait(1));

	// popup
	this.popup = new lib.Popup();
	this.popup.name = "popup";
	this.popup.setTransform(-0.2,-1.2,1,1,0,0,0,561.5,393.5);

	this.timeline.addTween(cjs.Tween.get(this.popup).wait(1));

	// rules
	this.rulesPanel = new lib.RulesPanelContainer();
	this.rulesPanel.name = "rulesPanel";
	this.rulesPanel.setTransform(2.75,-697.3,1,1,0,0,0,0,-0.5);

	this.timeline.addTween(cjs.Tween.get(this.rulesPanel).wait(1));

	// skip button
	this.skipButton = new lib.SkipButton();
	this.skipButton.name = "skipButton";
	this.skipButton.setTransform(425.35,-583.05,3.0138,3.0117,0,0,0,-0.2,2.7);

	this.timeline.addTween(cjs.Tween.get(this.skipButton).wait(1));

	// feedback
	this.feedbackPanel = new lib.FeedbackPanel();
	this.feedbackPanel.name = "feedbackPanel";
	this.feedbackPanel.setTransform(9.1,155.4,1,1,0,0,0,0.2,183.5);

	this.timeline.addTween(cjs.Tween.get(this.feedbackPanel).wait(1));

	// row button
	this.rowButton = new lib.StartGameButton();
	this.rowButton.name = "rowButton";
	this.rowButton.setTransform(1.95,723.65,3.0138,3.0117,0,0,0,-0.2,2.7);

	this.timeline.addTween(cjs.Tween.get(this.rowButton).wait(1));

	// level placeholder
	this.levelContainer = new lib.PlaceholderRound();
	this.levelContainer.name = "levelContainer";

	this.timeline.addTween(cjs.Tween.get(this.levelContainer).wait(1));

	// river
	this.instance = new lib.River();
	this.instance.setTransform(-666,-497);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg_elements
	this.instance_1 = new lib.RiverbankDown_1();
	this.instance_1.setTransform(-6.5,375.6,1,1,0,0,0,666.5,407.6);

	this.instance_2 = new lib.RiverbankUp_1();
	this.instance_2.setTransform(-6.5,-136.4,1,1,0,0,0,666.5,407.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1}]}).wait(1));

	// bg
	this.bg = new lib.GameScreenBackground();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GameScreenSkin, new cjs.Rectangle(-762.1,-2130.8,1841.5,3185.8), null);


// stage content:
(lib.MainAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// assets
	this.instance = new lib.WormSkin();
	this.instance.setTransform(1914.8,1938.8,1,1,0,0,0,2,-24.5);

	this.instance_1 = new lib.CarrotSkin();
	this.instance_1.setTransform(2016.15,568.15,1,1,0,0,0,2,-15.5);

	this.instance_2 = new lib.CaterpillarSkin();
	this.instance_2.setTransform(2083.3,1720.9,1,1,0,0,0,2,-53.5);

	this.instance_3 = new lib.LevelWith2SlotsSkin();
	this.instance_3.setTransform(2615.15,3797.15);

	this.instance_4 = new lib.GirlSkin();
	this.instance_4.setTransform(1506.85,826.55,1,1,0,0,0,2,-38);

	this.instance_5 = new lib.GooseSkin();
	this.instance_5.setTransform(1854.85,1721.6,1,1,0,0,0,2,-53.5);

	this.instance_6 = new lib.Boat3SkinNoSeats();
	this.instance_6.setTransform(1561.2,-1531.2,1,1,0,0,0,95.5,-147);

	this.instance_7 = new lib.CabbageSkin();
	this.instance_7.setTransform(1472.4,568.15,1,1,0,0,0,2,-15.5);

	this.instance_8 = new lib.Boat2SkinNoSeats();
	this.instance_8.setTransform(1522.7,-890.4,1,1,0,0,0,6.2,-40.2);

	this.instance_9 = new lib.BagSkin();
	this.instance_9.setTransform(1660.6,1443.9);

	this.instance_10 = new lib.DogSkin();
	this.instance_10.setTransform(1847.35,1440.5,1,1,0,0,0,-5.5,-24.4);

	this.instance_11 = new lib.LevelWith3SlotsSkin();
	this.instance_11.setTransform(2639.2,2519.25);

	this.instance_12 = new lib.Kid3Skin();
	this.instance_12.setTransform(1868.85,859.05,1,1,0,0,0,0,-5.5);

	this.instance_13 = new lib.BoySkin();
	this.instance_13.setTransform(1680.1,876.35,1,1,0,0,0,-0.1,-4.2);

	this.instance_14 = new lib.WomanSkin();
	this.instance_14.setTransform(1723.7,1123,1,1,0,0,0,13.5,-19.8);

	this.instance_15 = new lib.ManSkin();
	this.instance_15.setTransform(1508.95,1114.65,1,1,0,0,0,7,-20.3);

	this.instance_16 = new lib.LevelWith6SlotsSkin();
	this.instance_16.setTransform(2696.8,-822.5);

	this.instance_17 = new lib.SpiderSkin();
	this.instance_17.setTransform(1453,1746.4);

	this.instance_18 = new lib.LevelWith4SlotsSkin();
	this.instance_18.setTransform(2723.05,1281.2);

	this.instance_19 = new lib.SnailSkin();
	this.instance_19.setTransform(1653.55,1752.4,1,1,0,0,0,-1,-12);

	this.instance_20 = new lib.FoxSkin();
	this.instance_20.setTransform(1501.05,1973.9,1,1,0,0,0,-10.5,-29.5);

	this.instance_21 = new lib.ChickenSkin();
	this.instance_21.setTransform(1443.1,1446.3);

	this.instance_22 = new lib.Boat3Skin();
	this.instance_22.setTransform(1522.7,-55.7,1,1,0,0,0,6.2,-40.2);

	this.instance_23 = new lib.Boat2Skin();
	this.instance_23.setTransform(1522.7,-477.3,1,1,0,0,0,6.2,-41.6);

	this.instance_24 = new lib.LevelWith5SlotsSkin();
	this.instance_24.setTransform(2696.8,257.95);

	this.instance_25 = new lib.WolfSkin();
	this.instance_25.setTransform(1758.4,418.2);

	this.instance_26 = new lib.GoatSkin();
	this.instance_26.setTransform(1518.1,384.15);

	this.instance_27 = new lib.FarmerSkin();
	this.instance_27.setTransform(1763.25,597);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_27},{t:this.instance_26},{t:this.instance_25},{t:this.instance_24},{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// tutorial
	this.instance_28 = new lib.TutorialOverlaySkin();
	this.instance_28.setTransform(539.7,3389.45,1,1,0,0,0,3.8,-0.3);
	this.instance_28.cache(-1655,-1182,2741,2268);

	this.timeline.addTween(cjs.Tween.get(this.instance_28).wait(1));

	// gamescreen
	this.instance_29 = new lib.EndScreenSkin();
	this.instance_29.setTransform(-1041.5,870.95,1,1,0,0,0,0.5,-0.1);

	this.instance_30 = new lib.GameScreenSkin();
	this.instance_30.setTransform(539.8,862.6,1,1,0,0,0,-0.2,-8.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_30},{t:this.instance_29}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(-1168,-927.2,4927.1,5711.4);
// library properties:
lib.properties = {
	id: 'F7DD7F692B0D1D44A7B614DFFAE812BF',
	width: 1080,
	height: 1742,
	fps: 24,
	color: "#666666",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/MainAssets/Arrow.png", id:"MainAssets_Arrow", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Background_Blue.png", id:"MainAssets_Background_Blue", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Boy.png", id:"MainAssets_Boy", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Boy_ClosedEyes.png", id:"MainAssets_Boy_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_disabled.png", id:"MainAssets_Button_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_down.png", id:"MainAssets_Button_down", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_up.png", id:"MainAssets_Button_up", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Cabbage.png", id:"MainAssets_Cabbage", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Carrot.png", id:"MainAssets_Carrot", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Caterpillar.png", id:"MainAssets_Caterpillar", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Caterpillar_ClosedEyes.png", id:"MainAssets_Caterpillar_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/CharacterShadow.png", id:"MainAssets_CharacterShadow", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Chicken.png", id:"MainAssets_Chicken", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Chicken__ClosedEyes.png", id:"MainAssets_Chicken__ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Dog.png", id:"MainAssets_Dog", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Dog_ClosedEyes.png", id:"MainAssets_Dog_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Euromast.png", id:"MainAssets_Euromast", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Farmer.png", id:"MainAssets_Farmer", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Farmer_ClosedEyes.png", id:"MainAssets_Farmer_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Father.png", id:"MainAssets_Father", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Father_ClosedEyes.png", id:"MainAssets_Father_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FeedbackPopup_Left.png", id:"MainAssets_FeedbackPopup_Left", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FeedbackPopup_Middle.png", id:"MainAssets_FeedbackPopup_Middle", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FeedbackPopup_Right.png", id:"MainAssets_FeedbackPopup_Right", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Ferry.png", id:"MainAssets_Ferry", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Ferry_ClosedEyes.png", id:"MainAssets_Ferry_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish_01.png", id:"MainAssets_Fish_01", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish_02.png", id:"MainAssets_Fish_02", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Foreground_Splash.png", id:"MainAssets_Foreground_Splash", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fox.png", id:"MainAssets_Fox", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fox_ClosedEyes.png", id:"MainAssets_Fox_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/gatekeeper.png", id:"MainAssets_gatekeeper", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Girl.png", id:"MainAssets_Girl", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Girl_ClosedEyes.png", id:"MainAssets_Girl_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Goat.png", id:"MainAssets_Goat", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Goat_ClosedEyes.png", id:"MainAssets_Goat_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Goose.png", id:"MainAssets_Goose", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Goose_ClosedEyes.png", id:"MainAssets_Goose_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Grass.png", id:"MainAssets_Grass", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/GreyBackground.png", id:"MainAssets_GreyBackground", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/HappyGambit.png", id:"MainAssets_HappyGambit", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Kabouter.png", id:"MainAssets_Kabouter", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Kid.png", id:"MainAssets_Kid", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Kid_ClosedEyes.png", id:"MainAssets_Kid_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Mill.png", id:"MainAssets_Mill", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Mother.png", id:"MainAssets_Mother", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Mother_ClosedEyes.png", id:"MainAssets_Mother_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PopupBG.png", id:"MainAssets_PopupBG", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton.png", id:"MainAssets_PrevNextButton", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton_disabled.png", id:"MainAssets_PrevNextButton_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton_down.png", id:"MainAssets_PrevNextButton_down", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PullOutButton.png", id:"MainAssets_PullOutButton", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PullOutButton_disabled.png", id:"MainAssets_PullOutButton_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PullOutButton_down.png", id:"MainAssets_PullOutButton_down", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PullOutMenu.png", id:"MainAssets_PullOutMenu", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/River.png", id:"MainAssets_River", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/RiverbankDown.png", id:"MainAssets_RiverbankDown", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/RiverbankUp.png", id:"MainAssets_RiverbankUp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/SackGrain.png", id:"MainAssets_SackGrain", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Skip_disabled.png", id:"MainAssets_Skip_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Skip_down.png", id:"MainAssets_Skip_down", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Skip_up.png", id:"MainAssets_Skip_up", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/SlotArea.png", id:"MainAssets_SlotArea", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Snail.png", id:"MainAssets_Snail", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Snail_ClosedEyes.png", id:"MainAssets_Snail_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Spider.png", id:"MainAssets_Spider", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Spider_ClosedEyes.png", id:"MainAssets_Spider_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TopbarHUD.png", id:"MainAssets_TopbarHUD", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Tree.png", id:"MainAssets_Tree", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TutStep1.png", id:"MainAssets_TutStep1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TutStep2.png", id:"MainAssets_TutStep2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TutStep3.png", id:"MainAssets_TutStep3", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TutStep4.png", id:"MainAssets_TutStep4", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TutStep5.png", id:"MainAssets_TutStep5", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TutStep7.png", id:"MainAssets_TutStep7", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Wolf.png", id:"MainAssets_Wolf", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Wolf_ClosedEyes.png", id:"MainAssets_Wolf_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Worm.png", id:"MainAssets_Worm", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Worm_ClosedEyes.png", id:"MainAssets_Worm_ClosedEyes", bundle:"MainAssets"}
	],
	preloads: []
};



})(lib.MainAssets = {}, images, ss, createjs);
module.exports = lib.MainAssets;